/* ####################### CODE VERSION 5 ####################### */
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AppContext from "../../context/AppContext";
import { useAuth } from "../../context/useAuth";
import { http } from "../../api/http";
import {
  Button,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./ResultScreen.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

import Desert_Eurovent_Cerificate from "../../assets/images/desert_eurovent_certificate.png";
import DP_power_world_logo from "../../assets/images/DP_Power_world.png";
import Water_Chiller_1_Image from "../../assets/images/Water_chiller_bgr_1.png";
import Water_Chiller_2_Image from "../../assets/images/Water_chiller_bgr_2.png";
import Water_Chiller_3_Image from "../../assets/images/Water_chiller_bgr_3.png";
import Water_Chiller_4_Image from "../../assets/images/Water_chiller_bgr_4.png";
import Ecoval_logo from "../../assets/images/Ecoval_logo-removebg-preview.png";

/* --------------------------
    Filter Dropdown Component
-------------------------- */
const FilterControl = ({ label, value, onChange }) => (
  <label className="result-filter">
    <span>{label}</span>
    <Select
      size="small"
      value={value}
      onChange={onChange}
      className="result-filter__select"
    >
      <MenuItem value="ALL">All</MenuItem>
      <MenuItem value="OTHER">Other</MenuItem>
    </Select>
  </label>
);

export default function ResultScreen() {
  const navigate = useNavigate();
  const { user } = useAuth();
  

  const {
    base_URL,
    chillersList,
    setChillersList,
    selectedSeries,
    inletTemp,
    outletTemp,
    ambientTemp,
    coolingCapacity,
  } = useContext(AppContext);

  console.log(`App Context data`, selectedSeries, inletTemp, outletTemp, ambientTemp, coolingCapacity);
  
  const [range, setRange] = useState("ALL");
  const [version, setVersion] = useState("ALL");
  const [option, setOption] = useState("ALL");
  const [rows, setRows] = useState(chillersList);
  const [selectedRow, setSelectedRow] = useState(null);
  const [fetchError, setFetchError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);
  const [isFullProfileLoading, setIsFullProfileLoading] = useState(false);
  const [chillerFullProfile, setChillerFullProfile] = useState(null);

  const [pumpSelection, setPumpSelection] = useState({}); // Pump Option

  /* --------------------------
      SECTION CHECKBOX STATE
  -------------------------- */
  const [sectionState, setSectionState] = useState({
    // performanceParameters: true,
    operatingRanges: true,
    componentSummary: true,
    // design: true,
    // airDischarge :true,
    compressor: true,
    condenserFan: true,
    condenser: true,
    evaporator: true,
    // pump: true,
    controller: true,
    refrigerant: true,
    expansionValve: true,
    protections: true,
    physicalSpecs: true,
  });

  const toggleSection = (key) =>
    setSectionState((prev) => ({ ...prev, [key]: !prev[key] }));

  /* --------------------------
      TABLE COLUMNS
  -------------------------- */
  const columns = [
    {
      field: "eurovent_certified",
      headerName: "Eurovent Certified",
      width: 165,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const isCertified = params.row.eurovent_certified === true;

        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isCertified ? (
              <img
                src={Desert_Eurovent_Cerificate}
                alt="Eurovent"
                style={{ width: 100, height: 100, objectFit: "contain" }}
              />
            ) : (
              <span style={{ color: "#999", fontSize: 12 }}>—</span>
            )}
          </div>
        );
      },
    },
    { field: "series_code", headerName: "Series", width: 100 },
    { field: "option_code", headerName: "Model", width: 130 },
    // { field: "model_size", headerName: "Size", width: 110 },
    // { field: "version", headerName: "Version", width: 110 },
    // { field: "option_code", headerName: "Option", width: 115 },

    { field: "cooling_capacity", headerName: "Cooling (kW)", width: 140 },
    { field: "tpl", headerName: "Power TPL (kW)", width: 140 },
    { field: "eer", headerName: "EER (COP)", width: 110 },
    // { field: "seer", headerName: "SEER", width: 110 },

    { field: "refrigerant", headerName: "Refrigerant", width: 140 },
    { field: "compressor_type", headerName: "Compressor", width: 140 },
    { field: "evaporator_type", headerName: "Evaporator", width: 150 },
    { field: "fan_type", headerName: "Fan Type", width: 120 },
    // { field: "lw_flag", headerName: "Low Noise", width: 100, type: "boolean" },
    {
      field: "pump_select",
      headerName: "Pump Option",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const id = params.row.id;

        return (
          <input
            type="checkbox"
            checked={!!pumpSelection[id]}
            className="result-pump-checkbox"
            onChange={(e) => {
              setPumpSelection((prev) => ({
                ...prev,
                [id]: e.target.checked,
              }));
            }}
            style={{ width: 18, height: 18 }}
          />
        );
      },
    },
  ];

  /* --------------------------
      FETCH SEARCH RESULTS
  -------------------------- */
  useEffect(() => {        
    const tempsProvided =
      inletTemp !== "" && outletTemp !== "" && ambientTemp !== "";

    if (!selectedSeries.length || !tempsProvided) {
      setRows([]);
      setChillersList([]);
      return;
    }

    const fetchChillers = async () => {
      try {
        setIsLoading(true);
        setFetchError("");

        const payload = {
          seriesCodes: selectedSeries,
          inletTemp,
          outletTemp,
          ambientTemp,
          coolingCapacity,
        };

        const body = await http.post("/chillers/search", payload);
        console.log(`searched chillers list`, body);

        setRows(body.data ?? []);
        setChillersList(body.data ?? []);
      } catch (error) {
        setRows([]);
        setChillersList([]);
        setFetchError(error.message || "Fetch failed");
      } finally {
        setIsLoading(false);
      }
    };

    fetchChillers();
  }, [
    selectedSeries,
    inletTemp,
    outletTemp,
    ambientTemp,
    coolingCapacity,
    setChillersList,
  ]);

  /* --------------------------
      FETCH FULL PROFILE WHEN DIALOG OPENS
  -------------------------- */
  const openPdfDialog = async () => {
    if (!selectedRow) return;

    if (!inletTemp || !outletTemp || !ambientTemp) {
      toast.error("Operating conditions are missing");
      return;
    }

    setIsPdfDialogOpen(true);
    setIsFullProfileLoading(true);
    setChillerFullProfile(null);

    try {
      const chillerId = selectedRow.id;

      const data = await http.get(
        `/chillers/${chillerId}/full-profile` +
          `?inlet=${inletTemp}` +
          `&outlet=${outletTemp}` +
          `&ambient=${ambientTemp}`
      );
      console.log(`full profile data for chiller_id: ${chillerId}`, data);

      setChillerFullProfile(data);
    } catch (error) {
      console.error("Full profile fetch error:", error);
      toast.error("Failed to load full profile");
    } finally {
      setIsFullProfileLoading(false);
    }
  };

  const closePdfDialog = () => setIsPdfDialogOpen(false);

  const handleGenerateClick = () => {
    if (!selectedRow) {
      toast.warn("Choose a model from the Table");
      return;
    }
    openPdfDialog();
  };

  /* --------------------------
      PDF HELPERS
  -------------------------- */

  function drawHorizontalGradient(
    doc,
    x,
    y,
    width,
    height,
    startColor,
    endColor
  ) {
    const steps = 50;
    for (let i = 0; i < steps; i++) {
      const t = i / (steps - 1);
      const r = startColor[0] + t * (endColor[0] - startColor[0]);
      const g = startColor[1] + t * (endColor[1] - startColor[1]);
      const b = startColor[2] + t * (endColor[2] - startColor[2]);
      doc.setFillColor(r, g, b);
      doc.rect(x + (width / steps) * i, y, width / steps, height, "F");
    }
  }

  // const EXCLUDE_KEYS = new Set([
  //   "id",
  //   "chiller_id",
  //   "created_at",
  //   "updated_at",
  //   "make",
  //   "model",
  //   "motor_make",
  //   "motor_model",
  //   "plate_model",
  // ]);

  const shouldExcludeKey = (key) => {
    const k = key.toLowerCase();

    return (
      // exact technical fields
      k === "id" ||
      k === "chiller_id" ||

      // any key that ends with _id
      k.endsWith("_id") ||

      // timestamps
      k.endsWith("_at") ||

      // internal / technical fields
      k.includes("uuid") ||
      k.includes("created") ||
      k.includes("updated")
    );
  };

  const valueOrDash = (v) => {
    if (v === true) return "Yes";
    if (v === false) return "No";

    return v !== null && v !== undefined && v !== "" ? v : "—";
  };

  const formatDateTime = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    // return `${day}/${month}/${year} ${hours}:${minutes}`;
    return `${day}/${month}/${year}`;
  };

  // const findUnitForKey = (obj, key) => {
  //   // 1. exact match: key + "_unit"
  //   if (obj[key + "_unit"]) return obj[key + "_unit"];

  //   // 2. prefix match: cooling_capacity_min → cooling_capacity_unit
  //   const parts = key.split("_");
  //   if (parts.length > 1) {
  //     const prefix = parts.slice(0, -1).join("_");
  //     const unitKey = prefix + "_unit";
  //     if (obj[unitKey]) return obj[unitKey];
  //   }

  //   // 3. fallback for known patterns
  //   if (key.includes("temp")) return "°C";

  //   return "";
  // };

  // const findUnitForKey = (obj, key) => {
  //   // Explicit engineering mappings
  //   const unitMappings = {
  //     nominal_cooling_capacity: "cooling_capacity_unit",
  //     actual_cooling_capacity: "cooling_capacity_unit",

  //     running_power: "power_unit",
  //     maximum_power: "power_unit",

  //     running_current: "current_unit",
  //     maximum_current: "current_unit",

  //     inlet_temp: "inlet_temp_unit",
  //     outlet_temp: "outlet_temp_unit",
  //     ambient_temp: "ambient_temp_unit",

  //     altitude: "altitude_unit",
  //   };

  //   // 1. Explicit mapping lookup
  //   const mappedUnitKey = unitMappings[key];

  //   if (mappedUnitKey && obj[mappedUnitKey]) {
  //     return obj[mappedUnitKey];
  //   }

  //   // 2. Exact match fallback
  //   if (obj[key + "_unit"]) {
  //     return obj[key + "_unit"];
  //   }

  //   // 3. Temperature fallback
  //   if (key.includes("temp")) {
  //     return "°C";
  //   }

  //   return "";
  // };

  const findUnitForKey = (obj, key) => {
  // Explicit engineering mappings
  const unitMappings = {
    nominal_cooling_capacity: "cooling_capacity_unit",
    actual_cooling_capacity: "cooling_capacity_unit",

    running_power: "power_unit",
    maximum_power: "power_unit",

    running_current: "current_unit",
    maximum_current: "current_unit",

    inlet_temp: "inlet_temp_unit",
    outlet_temp: "outlet_temp_unit",
    ambient_temp: "ambient_temp_unit",

    altitude: "altitude_unit",
  };

  // ------------------------------------------------
  // 1. Explicit mapping lookup
  // ------------------------------------------------
  const mappedUnitKey = unitMappings[key];

  if (mappedUnitKey && obj[mappedUnitKey]) {
    return obj[mappedUnitKey];
  }

  // ------------------------------------------------
  // 2. Exact match fallback
  // Example:
  // pressure_drop -> pressure_drop_unit
  // ------------------------------------------------
  if (obj[key + "_unit"]) {
    return obj[key + "_unit"];
  }

  // ------------------------------------------------
  // 3. Prefix fallback
  // Example:
  // lra_max -> lra_unit
  // fla_max -> fla_unit
  // ------------------------------------------------
  const parts = key.split("_");

  if (parts.length > 1) {
    const prefix = parts.slice(0, -1).join("_");
    const unitKey = prefix + "_unit";

    if (obj[unitKey]) {
      return obj[unitKey];
    }
  }

  // ------------------------------------------------
  // 4. Generic temperature fallback
  // ------------------------------------------------
  if (key.includes("temp")) {
    return "°C";
  }

  return "";
};

  const buildSingleSection = (title, obj) => {
    if (!obj) return [];

    const rows = [];
    const keys = Object.keys(obj).filter(
      (k) => !shouldExcludeKey(k) && !k.endsWith("_unit")
    );

    rows.push([
      { content: title, gradient: true, styles: { fontStyle: "bold" } },
      "",
      "",
    ]);

    keys.forEach((key) => {
      const value = valueOrDash(obj[key]);
      const unit = findUnitForKey(obj, key);

      let label = key.replace(/_/g, " ").toUpperCase();

      // Custom labels for the Operating Ranges section only
      if (title === "Operating Ranges") {
        const labelMappings = {
          nominal_cop: "NOMINAL EER",
          actual_cop: "ACTUAL EER",
          inlet_temp: "INLET WATER TEMP",
          outlet_temp: "OUTLET WATER TEMP",
        };

        if (labelMappings[key]) {
          label = labelMappings[key];
        }
      }

      rows.push([label, unit, value]);
    });

    rows.push([
      { content: "", emptyRow: true, styles: { lineWidth: 0 } },
      { content: "", emptyRow: true, styles: { lineWidth: 0 } },
      { content: "", emptyRow: true, styles: { lineWidth: 0 } },
    ]);

    return rows;
  };

  const buildMultiSection = (title, rows) => {
    if (!rows || rows.length === 0) return [];

    // Always use first item from an array-based section
    const obj = Array.isArray(rows) ? rows[0] : rows;

    // Only include meaningful fields
    const keys = Object.keys(obj).filter(
      (k) => !shouldExcludeKey(k) && !k.endsWith("_unit")
    );

    if (keys.length === 0) return [];

    const detailRows = keys.map((key) => {
      const value = valueOrDash(obj[key]);
      const unit = findUnitForKey(obj, key); // <-- NEW UNIT DETECTION
      const label = key.replace(/_/g, " ").toUpperCase();

      return [
        label, // Description
        unit, // Unit
        value, // Value
      ];
    });

    // Build section heading
      const headingRow =
        title === "Pump"
          ? [
              {
                content: "Pump",
                gradient: true,
                styles: {
                  fontStyle: "bold",
                  fillColor: null,
                },
              },
             {
                content:
                 "* This Data generated with Pump Option is not Certified",
                gradient: false,
                colSpan: 2,
                styles: {
                  fontStyle: "normal",
                  fontSize: 7,
                  fillColor: null,
	          overflow: "visible",
                },
              },
              "",
            ]
          : [
              {
                content: title,
                gradient: true,
                styles: {
                  fontStyle: "bold",
                  fillColor: null,
                },
              },
              "",
              "",
            ];

    return [
      // Section title row (with gradient)
      headingRow,

      // All detail rows
      ...detailRows,

      // Empty spacer row for separation
      [
        { content: "", emptyRow: true, styles: { lineWidth: 0 } },
        { content: "", emptyRow: true, styles: { lineWidth: 0 } },
        { content: "", emptyRow: true, styles: { lineWidth: 0 } },
      ],
    ];
  };

  const loadImageAsDataURL = async (src) => {
    try {
      const response = await fetch(src);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn("Failed to load image for PDF", err);
      return null;
    }
  };

  const estimateSectionHeight = (rowCount) => {
    const rowHeight = 6; // safe for fontSize 8 + padding
    return rowCount * rowHeight;
  };

  const renderSectionSafely = ({
    doc,
    rows,
    cursorYRef,
    pageWidth,
    willDrawCell,
    didDrawCell,
  }) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    const bottomMargin = 25;
    const headerHeight = 25;

    const estimatedHeight = estimateSectionHeight(rows.length);

    // 🔴 Force full section to next page if it won't fit
    if (cursorYRef.y + estimatedHeight > pageHeight - bottomMargin) {
      doc.addPage();
      cursorYRef.y = headerHeight + 10;
    }

    autoTable(doc, {
      startY: cursorYRef.y,
      margin: { left: 10, right: 10 },
      theme: "plain",
      body: rows,
      styles: {
        fontSize: 8,
        cellPadding: 1.2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 72 },
        1: { cellWidth: 18, halign: "center" },
        2: { cellWidth: 100, halign: "center" },
      },
      willDrawCell,
      didDrawCell,
    });

    cursorYRef.y = doc.lastAutoTable.finalY + 5;
  };

  /* --------------------------
      GENERATE PDF
  -------------------------- */
  const handleGeneratePDF = async () => {
    if (!chillerFullProfile) {
      toast.warn("Profile not loaded yet");
      return;
    }

    const p = chillerFullProfile;
    const doc = new jsPDF("p", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const modelLabel = p.chiller.option_code;   // or we can use "p.chiller.model"
    const euroventDataUrl = p.chiller.eurovent_certified
      ? await loadImageAsDataURL(Desert_Eurovent_Cerificate)
      : null;
    const powerSupplyLabel = p.physical_specs.power_supply || "—";
    const ecovalLogoDataUrl = await loadImageAsDataURL(Ecoval_logo);

    /* ================= PAGE 1 (UNCHANGED) ================= */
    // 👉 KEEP YOUR EXISTING PAGE-1 CODE AS IS

    /* PAGE 1: COVER (inspired by reference) */
    const addAccentBar = (x, y, w = 22, h = 4) => {
      doc.setFillColor(240, 22, 29);
      doc.rect(x, y, w, h, "F");
    };

    // Logo area (centered with background band)
    const logoDataUrl = await loadImageAsDataURL(DP_power_world_logo);
    const logoBandHeight = 26;

    // Background band across the top
    doc.setFillColor(222, 245, 255); // dark brand-like color
    doc.rect(0, 0, pageWidth, logoBandHeight, "F");

    if (logoDataUrl) {
      const logoWidth = 60; // larger size for prominence
      const logoHeight = 22;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = (logoBandHeight - logoHeight) / 2;
      doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoWidth, logoHeight);
    } else {
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(12);
      doc.text("Company Logo", pageWidth / 2, logoBandHeight / 2 + 3, {
        align: "center",
      });
    }
    // doc.setTextColor(25, 25, 25);
    // doc.setFontSize(9);
    // doc.text(`Date: ${new Date().toLocaleDateString()}`, pageWidth - 12, 16, {
    //   align: "right",
    // });

    // Title block
    addAccentBar(10, 32, 28, 4);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(25, 25, 25);
    doc.setFontSize(20);
    doc.text("TECHNICAL SELECTION", 10, 44);
    doc.setFontSize(14);
    doc.text(`${selectedSeries} Series` || "Series", 10, 53);
    doc.setFont("Courier", "bolditalic");
    doc.setTextColor(90, 90, 90);
    doc.setFontSize(12);
    // doc.text("Chiller, air source for outdoor installation", 10, 66);
    const text = "Chiller, air source for outdoor installation";
    const x = 10;
    const y = 60;

    // Draw text
    doc.text(text, x, y);

    // Measure text width (important!)
    const textWidth = doc.getTextWidth(text);

    // Draw underline
    doc.setDrawColor(90, 90, 90);
    doc.setLineWidth(0.4);
    doc.line(x, y + 1.5, x + textWidth, y + 1.5);

    addAccentBar(10, 66, 28, 4);

    // ===== HERO IMAGE LAYOUT (1 BIG + 3 SMALL) =====
const imgBig = await loadImageAsDataURL(Water_Chiller_1_Image);
const img2 = await loadImageAsDataURL(Water_Chiller_2_Image);
const img3 = await loadImageAsDataURL(Water_Chiller_3_Image);
const img4 = await loadImageAsDataURL(Water_Chiller_4_Image);

// -------------------- SIZES --------------------
// for old images
// const bigWidth = 120;
// const bigHeight = 100;

// const smallWidth = 38;
// const smallHeight = 28;

// for new images
const bigWidth = 120;
const bigHeight = 120;

const smallWidth = 38;
const smallHeight = 38;

const gapX = 8;
const gapY = 2;

// -------------------- POSITIONING --------------------
const heroAreaTop = 115;
const heroAreaBottom = 180;

// TOTAL HEIGHT OF BOTH ROWS
const totalHeight = bigHeight + gapY + smallHeight;

// Center vertically in hero area
const startY =
  heroAreaTop + (heroAreaBottom - heroAreaTop - totalHeight) / 2;

// Center BIG image
const bigX = (pageWidth - bigWidth) / 2;

// Row 1 (BIG)
if (imgBig) {
  doc.addImage(imgBig, "PNG", bigX, startY, bigWidth, bigHeight);
}

// -------------------- SMALL ROW --------------------
const totalSmallWidth = smallWidth * 3 + gapX * 2;
const smallStartX = (pageWidth - totalSmallWidth) / 2;
const smallY = startY + bigHeight + gapY;

// Row 2 (SMALL 3)
if (img2)
  doc.addImage(img2, "PNG", smallStartX, smallY, smallWidth, smallHeight);

if (img3)
  doc.addImage(
    img3,
    "PNG",
    smallStartX + smallWidth + gapX,
    smallY,
    smallWidth,
    smallHeight
  );

if (img4)
  doc.addImage(
    img4,
    "PNG",
    smallStartX + (smallWidth + gapX) * 2,
    smallY,
    smallWidth,
    smallHeight
  );


    // Details table
    doc.setDrawColor(0, 0, 0);
    // Details (no table; label-value pairs)
    addAccentBar(10, 230, 28, 4);
    const detailsStartY = 242;
    const lineHeight = 7;
    const details = [
      ["Code", valueOrDash(p.chiller.option_code)],
      ["Version", valueOrDash(p.chiller.version)],
      ["Power supply", valueOrDash(powerSupplyLabel)],
    ];
    doc.setFontSize(9);
    details.forEach((row, idx) => {
      const y = detailsStartY + idx * lineHeight;
      doc.setFont("helvetica", "normal");
      doc.setTextColor(40, 40, 40);
      doc.text(row[0], 12, y);
      doc.setTextColor(0, 0, 0);
      doc.text(row[1], pageWidth - 12, y, { align: "right" });
      doc.setDrawColor(225, 225, 225);
      doc.setLineWidth(0.2);
      doc.line(12, y + 2, pageWidth - 12, y + 2);
    });

    addAccentBar(10, 265, 28, 4);

    // -------------------- FOOTER --------------------
    const footerY = 290;
      
    // Use your existing function
    const formattedDate = formatDateTime();
      
    // Replace with your actual username variable
    const userName = `${user.full_name}` || "User";
      
    // Footer text
    const footerText = `Ecoworld Chiller Selector v1.0.0  |  Database v1.0.0  |  ${userName}  |  ${formattedDate}`;
      
    // Draw logo (LEFT)
    if (ecovalLogoDataUrl) {
      doc.addImage(ecovalLogoDataUrl, "PNG", 12, footerY - 4, 20, 6);
    }

    // Styling
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
      
    // // Handle long text safely
    const splitFooter = doc.splitTextToSize(footerText, pageWidth - 20);
      
    // // Center align
    doc.text(splitFooter, pageWidth / 2, footerY, { align: "center" });


    /* ================= PAGE 2+ DATA ================= */
    doc.addPage();

    let cursorYRef = { y: 35 };

    const willDrawCell = (data) => {
      if (data.section === "body" && data.cell.raw && data.cell.raw.gradient) {
        drawHorizontalGradient(
          doc,
          data.cell.x,
          data.cell.y,
          data.cell.width,
          data.cell.height,
          [174, 174, 174],
          [255, 255, 255]
        );
      }
    };

    const didDrawCell = (data) => {
      if (data.section !== "body") return;
      if (data.cell.raw?.emptyRow) return;

      const { x, y, width, height } = data.cell;
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.2);
      doc.line(x, y + height, x + width, y + height);
    };

    /* ================= MODEL HEADER ================= */
    renderSectionSafely({
      doc,
      cursorYRef,
      pageWidth,
      willDrawCell,
      didDrawCell,
      rows: [
        [
          { content: "Model", gradient: true, styles: { fontStyle: "bold" } },
          "",
          modelLabel,
        ],
      ],
    });

    /* ================= SECTIONS (ATOMIC) ================= */

    // if (sectionState.performanceParameters) {
    //   renderSectionSafely({
    //     doc,
    //     cursorYRef,
    //     pageWidth,
    //     willDrawCell,
    //     didDrawCell,
    //     rows: buildSingleSection(
    //       "Performance Parameters",
    //       p.performance_parameters
    //     ),
    //   });
    // }

    if (sectionState.operatingRanges) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Operating Ranges", p.operating_ranges),
      });
    }

    // if (sectionState.design) {
    //   renderSectionSafely({
    //     doc,
    //     cursorYRef,
    //     pageWidth,
    //     willDrawCell,
    //     didDrawCell,
    //     rows: buildSingleSection("Design Parameters", p.design_parameters),
    //   });
    // }

    if (sectionState.condenser) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Condenser", p.condensers),
      });
    }

    if (sectionState.condenserFan) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Condenser Fan", p.condenser_fans),
      });
    }

    if (sectionState.evaporator) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Evaporator", p.evaporators),
      });
    }

    if (sectionState.compressor) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Compressor", p.compressors),
      });
    }

    if (pumpSelection[selectedRow?.id]) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Pump", p.circulation_pumps),
      });
    }

    if (sectionState.controller) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Controller", p.controller),
      });
    }

    if (sectionState.refrigerant) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Refrigerant", p.refrigerants),
      });
    }

    if (sectionState.expansionValve) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Expansion Valve", p.expansion_valves),
      });
    }

    if (sectionState.protections) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildMultiSection("Protections", p.protections),
      });
    }

    if (sectionState.componentSummary) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Component Summary", p.component_summary),
      });
    }

    if (sectionState.physicalSpecs) {
      renderSectionSafely({
        doc,
        cursorYRef,
        pageWidth,
        willDrawCell,
        didDrawCell,
        rows: buildSingleSection("Physical Specs", p.physical_specs),
      });
    }

    /* ================= HEADER / FOOTER ================= */
    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 2; i <= totalPages; i++) {
      doc.setPage(i);
      const pageHeight = doc.internal.pageSize.getHeight();

      // Header Section
      doc.setDrawColor(0);
      doc.line(10, 18, pageWidth - 10, 18);
      doc.line(10, pageHeight - 16, pageWidth - 10, pageHeight - 16);

      doc.setFontSize(9);
      doc.text("Technical selection", 10, 12);
      // doc.text(formatDateTime(), 10, 18);
      doc.text(formatDateTime(), pageWidth-26, 12);

      if (euroventDataUrl) {
        doc.addImage(euroventDataUrl, "JPEG", pageWidth / 2 - 12, 4, 24, 10);
      }

      // Draw logo (LEFT)
      if (ecovalLogoDataUrl) {
        doc.addImage(ecovalLogoDataUrl, "PNG", 12, pageHeight - 11, 20, 6);
      }

      // Footer section
      const formattedDate = formatDateTime();

      // Replace with your actual username variable
      const userName = `${user.full_name}` || "User";

      // Footer text
      const footerText = `Ecoworld Chiller Selector v1.0.0  |  Database v1.0.0  |  ${userName}  |  ${formattedDate}`;

      // Styling
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(100, 100, 100);

      // Handle long text safely
      const splitFooter = doc.splitTextToSize(footerText, pageWidth - 20);

      // Center align
      doc.text(splitFooter, pageWidth / 2, pageHeight - 7, { align: "center" });

      doc.text(`${i} of ${totalPages}`, pageWidth - 10, pageHeight - 7, {
        align: "right",
      });
    }

    doc.save(`SPEC_${modelLabel}.pdf`);
    closePdfDialog();
  };

  /* --------------------------
      JSX UI
  -------------------------- */
  return (
    <div className="result-screen">
      <header className="result-heading">
        <div className="result-heading__left">
          <Button
            variant="outlined"
            disableElevation
            onClick={() => navigate(-1)}
            sx={{
              minWidth: 44,
              height: 40,
              borderRadius: "16px",
              border: "none",
            }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 22, color: "#0f172a" }} />
          </Button>
          <div>
            <p>Selection</p>
            <h1>Results</h1>
          </div>
        </div>
        <span className="result-heading__meta">{rows.length} models</span>
      </header>

      <div className="result-toolbar">
        <div className="result-toolbar__filters">
          <FilterControl
            label="Range"
            value={range}
            onChange={(e) => setRange(e.target.value)}
          />
          <FilterControl
            label="Version"
            value={version}
            onChange={(e) => setVersion(e.target.value)}
          />
          <FilterControl
            label="Option"
            value={option}
            onChange={(e) => setOption(e.target.value)}
          />
        </div>
        {/* <FormControlLabel 
          control={
            <Checkbox 
              checked={includePump}
              onChange={() => setIncludePump(!includePump)}
            />
          }
          label="Include Pump"
        /> */}
        <Button
          variant="contained"
          disableElevation
          onClick={handleGenerateClick}
          aria-disabled={!selectedRow}
          sx={{
            textTransform: "none",
            padding: "10px 26px",
            borderRadius: "12px",
            backgroundColor: selectedRow ? "#0f172a" : "#E1E8F0",
            color: selectedRow ? "#fff" : "#94a3b8",
            cursor: selectedRow ? "pointer" : "not-allowed",
            "&:hover": {
              backgroundColor: selectedRow ? "#0c1328" : "#cbd5e1",
            },
          }}
          // className="result-toolbar__cta"
        >
          Generate PDF
        </Button>
      </div>

      {fetchError && <div className="result-error-banner">{fetchError}</div>}

      <div className="result-table">
        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          disableColumnMenu
          onRowClick={(params) =>
            setSelectedRow((prev) =>
              prev?.id === params.id ? null : params.row
            )
          }
          getRowClassName={(params) =>
            selectedRow?.id === params.id ? "selected-grid-row" : ""
          }
        />
      </div>

      {/* PDF DIALOG */}
      <Dialog
        open={isPdfDialogOpen}
        onClose={closePdfDialog}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "24px",
            backgroundColor: "#ffffff",
            boxShadow: "0 30px 80px rgba(15, 23, 42, 0.2)",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: 20, color: "#0f172a" }}>
          Export options
        </DialogTitle>

        <DialogContent dividers className="section-picker">
          <p>Select which sections you want to include in the PDF.</p>

          <FormGroup>
            <Grid container spacing={1}>
              {[
                // { key: "design", label: "Design parameters" },
                // { key: "airDischarge", label: "Air Discharge" },
                { key: "operatingRanges", label: "Operating Range" },
                { key: "compressor", label: "Compressor" },
                { key: "condenserFan", label: "Condenser Fan" },
                { key: "condenser", label: "Condenser" },
                { key: "evaporator", label: "Evaporator" },
                // { key: "pump", label: "Pump" },
                { key: "controller", label: "Controller" },
                { key: "refrigerant", label: "Refrigerant" },
                { key: "expansionValve", label: "Expansion Valve" },
                { key: "protections", label: "Protections" },
                { key: "physicalSpecs", label: "Physical Specs" },
                // { key: "performanceParameters", label: "Performance Parameters", },
                { key: "componentSummary", label: "Component Summary" },
              ].map((item) => (
                <Grid item xs={6} key={item.key}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sectionState[item.key]}
                        onChange={() => toggleSection(item.key)}
                      />
                    }
                    label={item.label}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px", gap: 1.5 }}>
          <Button
            sx={{
              backgroundColor: "#0f172a27",
              color: "#0f172a",
              borderRadius: "12px",
              padding: "10px 20px",
            }}
            onClick={closePdfDialog}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0f172a",
              color: "#fff",
              borderRadius: "12px",
              padding: "10px 20px",

            }}
            onClick={handleGeneratePDF}
            disabled={isFullProfileLoading || !chillerFullProfile}
          >
            {isFullProfileLoading ? "Loading..." : "Download PDF"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

/* ####################### CODE VERSION 4 ####################### */

// import { useState, useEffect, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import AppContext from "../../context/AppContext";
// import {
//   Button,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
//   Grid,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import "./ResultScreen.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { toast } from "react-toastify";
// import Desert_Eurovent_Cerificate from "../../assets/images/desert_eurovent_certificate.png";
// // import Ecoval_logo from "../../assets/images/Ecoval_logo.png";
// import DP_power_world_logo from "../../assets/images/DP_Power_world.png";
// import Water_Chiller_1_Image from "../../assets/images/Water_chiller_1.png";

// /* --------------------------
//     Filter Dropdown Component
// -------------------------- */
// const FilterControl = ({ label, value, onChange }) => (
//   <label className="result-filter">
//     <span>{label}</span>
//     <Select
//       size="small"
//       value={value}
//       onChange={onChange}
//       className="result-filter__select"
//     >
//       <MenuItem value="ALL">ALL</MenuItem>
//     </Select>
//   </label>
// );

// export default function ResultScreen() {
//   const navigate = useNavigate();

//   const {
//     base_URL,
//     chillersList,
//     setChillersList,
//     selectedSeries,
//     inletTemp,
//     outletTemp,
//     ambientTemp,
//   } = useContext(AppContext);

//   const [range, setRange] = useState("ALL");
//   const [version, setVersion] = useState("ALL");
//   const [option, setOption] = useState("ALL");
//   const [rows, setRows] = useState(chillersList);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [fetchError, setFetchError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);
//   const [isFullProfileLoading, setIsFullProfileLoading] = useState(false);
//   const [chillerFullProfile, setChillerFullProfile] = useState(null);

//   const [pumpSelection, setPumpSelection] = useState({}); // Pump Option

//   /* --------------------------
//       SECTION CHECKBOX STATE
//   -------------------------- */
//   const [sectionState, setSectionState] = useState({
//     performanceParameters: true,
//     componentSummary: true,
//     design: true,
//     // airDischarge :true,
//     compressor: true,
//     condenserFan: true,
//     condenser: true,
//     evaporator: true,
//     // pump: true,
//     controller: true,
//     refrigerant: true,
//     expansionValve: true,
//     protections: true,
//     physicalSpecs: true,
//   });

//   const toggleSection = (key) =>
//     setSectionState((prev) => ({ ...prev, [key]: !prev[key] }));

//   /* --------------------------
//       TABLE COLUMNS
//   -------------------------- */
//   const columns = [
//     // {
//     //   field: "eurovent_certified",
//     //   headerName: "Eurovent Certified",
//     //   width: 165,
//     //   sortable: false,
//     //   filterable: false,
//     //   renderCell: () => (
//     //     <div
//     //       style={{
//     //         width: "100%",
//     //         height: "100%",
//     //         display: "flex",
//     //         justifyContent: "center",
//     //         alignItems: "center",
//     //       }}
//     //     >
//     //       <img
//     //         src={Eurovent_Cerificate}
//     //         alt="Eurovent"
//     //         style={{ width: 70, height: 70, objectFit: "contain" }}
//     //       />
//     //     </div>
//     //   ),
//     // },
//     {
//       field: "eurovent_certified",
//       headerName: "Eurovent Certified",
//       width: 165,
//       sortable: false,
//       filterable: false,
//       renderCell: (params) => {
//         const isCertified = params.row.eurovent_certified === true;

//         return (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             {isCertified ? (
//               <img
//                 src={Desert_Eurovent_Cerificate}
//                 alt="Eurovent"
//                 style={{ width: 100, height: 100, objectFit: "contain" }}
//               />
//             ) : (
//               <span style={{ color: "#999", fontSize: 12 }}>
//                 —
//               </span>
//             )}
//           </div>
//         );
//       },
//     },
//     { field: "series_code", headerName: "Series", width: 100 },
//     { field: "model", headerName: "Model", width: 130 },
//     // { field: "model_size", headerName: "Size", width: 110 },
//     // { field: "version", headerName: "Version", width: 110 },
//     // { field: "option_code", headerName: "Option", width: 115 },

//     { field: "cooling_capacity", headerName: "Cooling (kW)", width: 140 },
//     { field: "tpl", headerName: "Power TPL (kW)", width: 140 },
//     { field: "eer", headerName: "EER (COP)", width: 110 },
//     // { field: "seer", headerName: "SEER", width: 110 },

//     { field: "refrigerant", headerName: "Refrigerant", width: 140 },
//     { field: "compressor_type", headerName: "Compressor", width: 140 },
//     { field: "evaporator_type", headerName: "Evaporator", width: 140 },
//     { field: "fan_type", headerName: "Fan Type", width: 120 },
//     // { field: "lw_flag", headerName: "Low Noise", width: 100, type: "boolean" },
//     {
//       field: "pump_select",
//       headerName: "Pump Option",
//       width: 120,
//       sortable: false,
//       filterable: false,
//       renderCell: (params) => {
//         const id = params.row.id;

//         return (
//           <input
//             type="checkbox"
//             checked={!!pumpSelection[id]}
//             className="result-pump-checkbox"
//             onChange={(e) => {
//               setPumpSelection((prev) => ({
//                 ...prev,
//                 [id]: e.target.checked,
//               }));
//             }}
//             style={{ width: 18, height: 18 }}
//           />
//         );
//       },
//     },
//   ];

//   /* --------------------------
//       FETCH SEARCH RESULTS
//   -------------------------- */
//   useEffect(() => {
//     const tempsProvided =
//       inletTemp !== "" && outletTemp !== "" && ambientTemp !== "";

//     if (!selectedSeries.length || !tempsProvided) {
//       setRows([]);
//       setChillersList([]);
//       return;
//     }

//     const controller = new AbortController();

//     const fetchChillers = async () => {
//       try {
//         setIsLoading(true);
//         setFetchError("");

//         const payload = {
//           seriesCodes: selectedSeries,
//           inletTemp,
//           outletTemp,
//           ambientTemp,
//         };

//         const response = await fetch(`${base_URL}/api/chillers/search`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//           signal: controller.signal,
//         });

//         const body = await response.json();
//         console.log(`searched chillers list}`, body);

//         if (!response.ok) throw new Error(body?.error || "Fetch failed");

//         setRows(body.data ?? []);
//         setChillersList(body.data ?? []);
//       } catch (error) {
//         if (error.name === "AbortError") return;
//         setRows([]);
//         setChillersList([]);
//         setFetchError(error.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchChillers();
//     return () => controller.abort();
//   }, [
//     base_URL,
//     selectedSeries,
//     inletTemp,
//     outletTemp,
//     ambientTemp,
//     setChillersList,
//   ]);

//   /* --------------------------
//       FETCH FULL PROFILE WHEN DIALOG OPENS
//   -------------------------- */
//   const openPdfDialog = async () => {
//     if (!selectedRow) return;

//     setIsPdfDialogOpen(true);
//     setIsFullProfileLoading(true);
//     setChillerFullProfile(null);

//     try {
//       const chillerId = selectedRow.id;
//       const response = await fetch(
//         `${base_URL}/api/chillers/${chillerId}/full-profile`
//       );

//       if (!response.ok) throw new Error("Failed to load full profile");

//       const data = await response.json();
//       console.log(`full profile data for chiller_id: ${chillerId}`, data);
//       setChillerFullProfile(data);
//     } catch (error) {
//       toast.error("Failed to load full profile");
//     } finally {
//       setIsFullProfileLoading(false);
//     }
//   };

//   const closePdfDialog = () => setIsPdfDialogOpen(false);

//   const handleGenerateClick = () => {
//     if (!selectedRow) {
//       toast.warn("Choose a model from the Table");
//       return;
//     }
//     openPdfDialog();
//   };

//   /* --------------------------
//       PDF HELPERS
//   -------------------------- */

//   function drawHorizontalGradient(
//     doc,
//     x,
//     y,
//     width,
//     height,
//     startColor,
//     endColor
//   ) {
//     const steps = 50;
//     for (let i = 0; i < steps; i++) {
//       const t = i / (steps - 1);
//       const r = startColor[0] + t * (endColor[0] - startColor[0]);
//       const g = startColor[1] + t * (endColor[1] - startColor[1]);
//       const b = startColor[2] + t * (endColor[2] - startColor[2]);
//       doc.setFillColor(r, g, b);
//       doc.rect(x + (width / steps) * i, y, width / steps, height, "F");
//     }
//   }

//   const EXCLUDE_KEYS = new Set([
//     "id",
//     "chiller_id",
//     "created_at",
//     "updated_at",
//     "make",
//     "model",
//     "motor_make",
//     "motor_model",
//     "plate_model",
//   ]);

//   const valueOrDash = (v) => {
//     if (v === true) return "Yes";
//     if (v === false) return "No";

//     return v !== null && v !== undefined && v !== "" ? v : "—";
//   };

//   // const buildSingleSection = (title, obj) => {
//   //   if (!obj) return [];

//   //   const filtered = Object.entries(obj).filter(
//   //     ([key]) => !EXCLUDE_KEYS.has(key)
//   //   );

//   //   return [
//   //     [
//   //       // {
//   //       //   content: sno,
//   //       //   rowSpan: filtered.length + 1 + 1, //added a empty row
//   //       //   styles: { valign: "top", halign: "center" },
//   //       // },
//   //       // { content: title, styles: { fontStyle: "bold" } },
//   //       {
//   //         content: title,
//   //         gradient: true, // <-- mark this row as needing gradient
//   //         styles: { fontStyle: "bold", fillColor: null },
//   //       },
//   //       "",
//   //       "",
//   //       // "",
//   //     ],
//   //     ...filtered.map(([key, val]) => [
//   //       key.replace(/_/g, " ").toUpperCase(),
//   //       "",
//   //       valueOrDash(val),
//   //       "",
//   //     ]),

//   //     // --- Two blank rows ---
//   //     [
//   //     // { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     ],
//   //     // [
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     // ]
//   //   ];
//   // };

//   // const buildMultiSection = (title, rows) => {
//   //   if (!rows || rows.length === 0) return [];

//   //   // Take only first object if needed
//   //   const firstRow = Array.isArray(rows) ? rows[0] : rows;

//   //   const filtered = Object.entries(firstRow).filter(
//   //     ([key]) => !EXCLUDE_KEYS.has(key)
//   //   );

//   //   if (filtered.length === 0) return [];

//   //   const detailRows = filtered.map(([key, val]) => [
//   //     `${key.replace(/_/g, " ").toUpperCase()}`,
//   //     "",
//   //     valueOrDash(val),
//   //     "",
//   //   ]);

//   //   return [
//   //     [
//   //       // {
//   //       //   content: sno,
//   //       //   rowSpan: detailRows.length + 1 + 1, //addeda empty row
//   //       //   styles: { valign: "top", halign: "center" },
//   //       // },
//   //       // { content: title,
//   //       //   styles: { fontStyle: "bold", fillColor: [217, 217, 217] }
//   //       // },
//   //       {
//   //         content: title,
//   //         gradient: true, // <-- mark this row as needing gradient
//   //         styles: { fontStyle: "bold", fillColor: null },
//   //       },
//   //       "",
//   //       "",
//   //       // ""
//   //     ],
//   //     ...detailRows,

//   //     // --- Two blank rows ---
//   //     [
//   //     // { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//   //     ],
//   //     // [
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     //   { content: "", styles: { lineWidth: 0, fillColor: null } },
//   //     // ]
//   //   ];
//   // };

//   const findUnitForKey = (obj, key) => {
//   // 1. exact match: key + "_unit"
//   if (obj[key + "_unit"]) return obj[key + "_unit"];

//   // 2. prefix match: cooling_capacity_min → cooling_capacity_unit
//   const parts = key.split("_");
//   if (parts.length > 1) {
//     const prefix = parts.slice(0, -1).join("_");
//     const unitKey = prefix + "_unit";
//     if (obj[unitKey]) return obj[unitKey];
//   }

//   // 3. fallback for known patterns
//   if (key.includes("temp")) return "°C";

//   return "";
// };

// const buildSingleSection = (title, obj) => {
//   if (!obj) return [];

//   const rows = [];
//   const keys = Object.keys(obj).filter(k => !EXCLUDE_KEYS.has(k) && !k.endsWith("_unit"));

//   rows.push([
//     { content: title, gradient: true, styles: { fontStyle: "bold" } },
//     "",
//     "",
//   ]);

//   keys.forEach((key) => {
//     const value = valueOrDash(obj[key]);
//     const unit = findUnitForKey(obj, key);

//     const label = key.replace(/_/g, " ").toUpperCase();

//     rows.push([label, unit, value]);
//   });

//   rows.push([
//     { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//     { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//     { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//   ]);

//   return rows;
// };

// const buildMultiSection = (title, rows) => {
//   if (!rows || rows.length === 0) return [];

//   // Always use first item from an array-based section
//   const obj = Array.isArray(rows) ? rows[0] : rows;

//   // Only include meaningful fields
//   const keys = Object.keys(obj).filter(
//     (k) => !EXCLUDE_KEYS.has(k) && !k.endsWith("_unit")
//   );

//   if (keys.length === 0) return [];

//   const detailRows = keys.map((key) => {
//     const value = valueOrDash(obj[key]);
//     const unit = findUnitForKey(obj, key); // <-- NEW UNIT DETECTION
//     const label = key.replace(/_/g, " ").toUpperCase();

//     return [
//       label,     // Description
//       unit,      // Unit
//       value      // Value
//     ];
//   });

//   return [
//     // Section title row (with gradient)
//     [
//       {
//         content: title,
//         gradient: true,
//         styles: { fontStyle: "bold", fillColor: null },
//       },
//       "",
//       "",
//     ],

//     // All detail rows
//     ...detailRows,

//     // Empty spacer row for separation
//     [
//       { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//       { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//       { content: "", emptyRow: true, styles: { lineWidth: 0 } },
//     ],
//   ];
// };

//   /* --------------------------
//       GENERATE PDF
//   -------------------------- */
//   const loadImageAsDataURL = async (src) => {
//     try {
//       const response = await fetch(src);
//       const blob = await response.blob();
//       return await new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onloadend = () => resolve(reader.result);
//         reader.onerror = reject;
//         reader.readAsDataURL(blob);
//       });
//     } catch (err) {
//       console.warn("Failed to load image for PDF", err);
//       return null;
//     }
//   };

//   const handleGeneratePDF = async () => {
//     if (!chillerFullProfile) {
//       toast.warn("Profile is not loaded yet");
//       return;
//     }

//     const p = chillerFullProfile;
//     const doc = new jsPDF("p", "mm", "a4");

//     const modelLabel = p.chiller.model;
//     const sizeLabel = p.chiller.model_size;
//     const euroventDataUrl = p.chiller.eurovent_certified ? await loadImageAsDataURL(Desert_Eurovent_Cerificate) : null;
//     // const ecoval_logoDataUrl = await loadImageAsDataURL(Ecoval_logo);
//     const powerSupplyLabel = p.physical_specs.power_supply || "—";

//     /* PAGE 1: COVER (inspired by reference) */
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const addAccentBar = (x, y, w = 22, h = 4) => {
//       doc.setFillColor(240, 22, 29);
//       doc.rect(x, y, w, h, "F");
//     };

//     // Logo + date (no top band)
//     const logoDataUrl = await loadImageAsDataURL(DP_power_world_logo);
//     if (logoDataUrl) {
//       doc.addImage(logoDataUrl, "PNG", 10, 6, 38, 14);
//     } else {
//       doc.setTextColor(80, 80, 80);
//       doc.text("Company Logo", 10, 16);
//     }
//     // doc.setTextColor(25, 25, 25);
//     // doc.setFontSize(9);
//     // doc.text(`Date: ${new Date().toLocaleDateString()}`, pageWidth - 12, 16, {
//     //   align: "right",
//     // });

//     // Title block
//     addAccentBar(10, 32, 28, 4);
//     doc.setTextColor(25, 25, 25);
//     doc.setFontSize(20);
//     doc.text("TECHNICAL SELECTION", 10, 48);
//     doc.setFontSize(12);
//     doc.text(`${selectedSeries} Series` || "Series", 10, 58);
//     doc.setTextColor(90, 90, 90);
//     doc.setFontSize(12);
//     // doc.text("Chiller, air source for outdoor installation", 10, 66);
//     const text = "Chiller, air source for outdoor installation";
//     const x = 10;
//     const y = 66;

//     // Draw text
//     doc.text(text, x, y);

//     // Measure text width (important!)
//     const textWidth = doc.getTextWidth(text);

//     // Draw underline
//     doc.setDrawColor(90, 90, 90);
//     doc.setLineWidth(0.4);
//     doc.line(x, y + 1.5, x + textWidth, y + 1.5);

//     // Hero image (centered)
//     const productDataUrl = await loadImageAsDataURL(Water_Chiller_1_Image);
//     const heroWidth = 120;
//     const heroHeight = 100;
//     const heroAreaTop = 88;
//     const heroAreaBottom = 172;
//     const heroX = (pageWidth - heroWidth) / 2;
//     const heroY = heroAreaTop + (heroAreaBottom - heroAreaTop - heroHeight) / 2;

//     if (productDataUrl) {
//       doc.addImage(productDataUrl, "PNG", heroX, heroY, heroWidth, heroHeight);
//     } else {
//       doc.setDrawColor(180, 180, 180);
//       doc.rect(heroX, heroY, heroWidth, heroHeight);
//       doc.text("Product image", heroX + 12, heroY + heroHeight / 2);
//     }

//     // Details table
//     doc.setDrawColor(0, 0, 0);
//     // Details (no table; label-value pairs)
//     addAccentBar(10, 205, 28, 4);
//     const detailsStartY = 220;
//     const lineHeight = 7;
//     const details = [
//       ["Code", valueOrDash(p.chiller.model)],
//       ["Version", valueOrDash(p.chiller.version)],
//       // ["Size", valueOrDash(sizeLabel)],
//       ["Power supply", valueOrDash(powerSupplyLabel)],
//     ];
//     doc.setFontSize(9);
//     details.forEach((row, idx) => {
//       const y = detailsStartY + idx * lineHeight;
//       doc.setTextColor(40, 40, 40);
//       doc.text(row[0], 12, y);
//       doc.setTextColor(0, 0, 0);
//       doc.text(row[1], pageWidth - 12, y, { align: "right" });
//       doc.setDrawColor(225, 225, 225);
//       doc.setLineWidth(0.2);
//       doc.line(12, y + 2, pageWidth - 12, y + 2);
//     });

//     /* PAGE 2: DATA SECTIONS */
//     doc.addPage();
//     // doc.setFontSize(14);
//     // doc.text("Data Sheet", 12, 32);

//     /* MAIN CONTENT */
//     let bodyRows = [];
//     // let sno = 2;
//     bodyRows.push([
//       // { content: "1", styles: { halign: "center" } },
//       { content: "Model", gradient: true, styles: { fontStyle: "bold" } },     // ← enable gradient
//       "",
//       { content: modelLabel }
//     ]);
//     // bodyRows.push(["", "", ""]);
//     bodyRows.push([
//       { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//       { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//       { content: "", emptyRow: true, styles: { lineWidth: 0, fillColor: null } },
//     ]);

//     if (sectionState.performanceParameters)
//       bodyRows.push(
//         ...buildSingleSection( "Performance Parameters", p.performance_parameters )
//       );

//     if (sectionState.componentSummary)
//       bodyRows.push(
//         ...buildSingleSection("Component Summary", p.component_summary)
//       );

//     if (sectionState.design)
//       bodyRows.push(
//         ...buildSingleSection("Design Parameters", p.design_parameters)
//       );

//     // if (sectionState.airDischarge)
//     //   bodyRows.push(
//     //     ...buildSingleSection("Air Discharge", p.air_discharge)
//     //   );

//     if (sectionState.compressor)
//       bodyRows.push(
//         ...buildMultiSection("Compressor", p.compressors)
//       );

//     if (sectionState.condenser)
//       bodyRows.push(
//         ...buildSingleSection("Condenser", p.condensers)
//       );

//     if (sectionState.condenserFan)
//       bodyRows.push(
//         ...buildMultiSection("Condenser Fan", p.condenser_fans)
//       );

//     if (sectionState.evaporator)
//       bodyRows.push(
//         ...buildSingleSection("Evaporator", p.evaporators)
//       );

//     // if (sectionState.pump)
//     //   bodyRows.push(
//     //     ...buildMultiSection("Pump", p.circulation_pumps)
//     //   );

//     const selectedPump = pumpSelection[selectedRow?.id] === true;

//     if (selectedPump) {
//       bodyRows.push(
//         ...buildMultiSection("Pump", p.circulation_pumps)
//       );
//     }

//     if (sectionState.controller)
//       bodyRows.push(
//         ...buildSingleSection("Controller", p.controller)
//       );

//     if (sectionState.refrigerant)
//       bodyRows.push(
//         ...buildMultiSection("Refrigerant", p.refrigerants)
//       );

//     if (sectionState.expansionValve)
//       bodyRows.push(
//         ...buildMultiSection("Expansion Valve", p.expansion_valves)
//       );

//     if (sectionState.protections)
//       bodyRows.push(
//         ...buildMultiSection("Protections", p.protections))
//         ;

//     if (sectionState.physicalSpecs)
//       bodyRows.push(
//         ...buildSingleSection("Physical Specs", p.physical_specs)
//     );

//     /* FINAL TABLE */
//     // Define safe header/footer spacing for all pages
//     const headerHeight = 25; // space below header before table starts
//     const footerHeight = 25; // space above footer after table ends

//     autoTable(doc, {
//       startY: headerHeight + 10,
//       margin: {
//         left: 10,
//         right: 10,
//         top: headerHeight, // space below header
//         bottom: footerHeight, // space above footer
//       },
//       theme: "plain",
//       // head: [["Description", "Unit", "PW"]],
//       body: bodyRows,
//       // headStyles: {
//       //   fillColor: [255, 255, 255],
//       //   textColor: [0, 0, 0],
//       //   fontStyle: "bold",
//       //   halign: "center",
//       //   fontSize: 8,
//       // },
//       styles: {
//         cellPadding: 1.2,
//         //  lineWidth: 0.3,
//         //  lineColor: [0, 0, 0],
//         fontSize: 8,
//         overflow: "linebreak",
//       },
//       columnStyles: {
//         // 0: { cellWidth: 12, halign: "center" },
//         0: { cellWidth: 72 },
//         1: { cellWidth: 18, halign: "center" },
//         2: { cellWidth: 100, halign: "center" }, // PW (internally split)
//         //  4: { cellWidth: 20, halign: "center" },
//       },
//       // columnStyles: {
//       //   0: { cellWidth: 12, halign: "center" },
//       //   1: { cellWidth: 60 },
//       //   1: { cellWidth: 12, halign: "center" },
//       //   3: { cellWidth: 86, halign: "center" }, // PW (internally split)
//       //   4: { cellWidth: 20, halign: "center" },
//       // },
//       /* Apply gradient backgrounds */
//       willDrawCell: function (data) {
//         if (
//           data.section === "body" &&
//           data.cell.raw &&
//           data.cell.raw.gradient === true // detect our tagged title row
//         ) {
//           const { x, y, width, height } = data.cell;

//           drawHorizontalGradient(
//             doc,
//             x,
//             y,
//             width,
//             height,
//             [174, 174, 174], // start (left)
//             [255, 255, 255] // end (right)
//             // [233, 233, 233] // end (right)
//           );
//         }
//       },
//       /* Draw horizontal line for each row except empty rows */
//       didDrawCell: function (data) {
//         if (data.section === "body") {
//           const raw = data.cell.raw;

//           // Skip empty rows
//           if (raw && raw.emptyRow) return;

//           const doc = data.doc;
//           const { x, y, width, height } = data.cell;

//           doc.setDrawColor(200, 200, 200); // light grey line
//           doc.setLineWidth(0.2);
//           doc.line(x, y + height, x + width, y + height);  // bottom line
//         }
//       },
//     });

//     /* HEADER & FOOTER FOR PAGES 2+ */
//     const totalPages = doc.internal.getNumberOfPages();
//     for (let pageNumber = 2; pageNumber <= totalPages; pageNumber += 1) {
//       doc.setPage(pageNumber);
//       const pageHeight = doc.internal.pageSize.getHeight();

//       // Header background
//       doc.setFillColor(255, 255, 255);
//       doc.rect(0, 0, pageWidth, 18, "F");

//       // Header content
//       doc.setTextColor(40, 40, 40);
//       doc.setFontSize(9);
//       doc.text("Technical selection", 10, 12);
//       if (p.chiller.eurovent_certified && euroventDataUrl) {
//         doc.addImage(euroventDataUrl, "JPEG", pageWidth / 2 - 12, 4, 24, 10);
//       }
//       doc.text(modelLabel || "", pageWidth - 10, 12, { align: "right" });

//       // Header line
//       doc.setDrawColor(0, 0, 0);
//       doc.setLineWidth(0.3);
//       doc.line(10, 18, pageWidth - 10, 18);

//       // Footer line
//       const footerLineY = pageHeight - 16;
//       doc.line(10, footerLineY, pageWidth - 10, footerLineY);

//       // Footer Y-position (baseline)
//       const footerContentY = footerLineY + 12;

//       // Footer content
//       // if (ecoval_logoDataUrl) {
//       //   const logoWidth = 20;
//       //   const logoHeight = 9;

//       //   doc.addImage(
//       //     ecoval_logoDataUrl,
//       //     "JPEG",
//       //     (pageWidth - logoWidth) / 2, // perfectly center horizontally
//       //     footerContentY - logoHeight + 2, // align with text baseline
//       //     logoWidth,
//       //     logoHeight
//       //   );
//       // }
//       doc.setTextColor(40, 40, 40);
//       doc.setFontSize(9);
//       doc.text(
//         `${pageNumber} of ${totalPages}`,
//         pageWidth - 10,
//         footerContentY,
//         { align: "right" }
//       );
//     }

//     doc.save(`SPEC_${modelLabel}_${sizeLabel}.pdf`);
//     closePdfDialog();
//   };

//   /* --------------------------
//       JSX UI
//   -------------------------- */
//   return (
//     <div className="result-screen">
//       <header className="result-heading">
//         <div className="result-heading__left">
//           <Button
//             variant="outlined"
//             disableElevation
//             onClick={() => navigate(-1)}
//             sx={{
//               minWidth: 44,
//               height: 40,
//               borderRadius: "16px",
//               border: "none",
//             }}
//           >
//             <ArrowBackIosNewIcon sx={{ fontSize: 22, color: "#0f172a" }} />
//           </Button>
//           <div>
//             <p>Selection</p>
//             <h1>Results</h1>
//           </div>
//         </div>
//         <span className="result-heading__meta">{rows.length} models</span>
//       </header>

//       <div className="result-toolbar">
//         <div className="result-toolbar__filters">
//           <FilterControl
//             label="Range"
//             value={range}
//             onChange={(e) => setRange(e.target.value)}
//           />
//           <FilterControl
//             label="Version"
//             value={version}
//             onChange={(e) => setVersion(e.target.value)}
//           />
//           <FilterControl
//             label="Option"
//             value={option}
//             onChange={(e) => setOption(e.target.value)}
//           />
//         </div>
//         {/* <FormControlLabel
//           control={
//             <Checkbox
//               checked={includePump}
//               onChange={() => setIncludePump(!includePump)}
//             />
//           }
//           label="Include Pump"
//         /> */}
//         <Button
//           variant="contained"
//           disableElevation
//           onClick={handleGenerateClick}
//           aria-disabled={!selectedRow}
//           sx={{
//             textTransform: "none",
//             padding: "10px 26px",
//             borderRadius: "12px",
//             backgroundColor: selectedRow ? "#0f172a" : "#E1E8F0",
//             color: selectedRow ? "#fff" : "#94a3b8",
//             cursor: selectedRow ? "pointer" : "not-allowed",
//             "&:hover": {
//               backgroundColor: selectedRow ? "#0c1328" : "#cbd5e1",
//             },
//           }}
//           // className="result-toolbar__cta"
//         >
//           Generate PDF
//         </Button>
//       </div>

//       {fetchError && <div className="result-error-banner">{fetchError}</div>}

//       <div className="result-table">
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           loading={isLoading}
//           disableColumnMenu
//           onRowClick={(params) =>
//             setSelectedRow((prev) =>
//               prev?.id === params.id ? null : params.row
//             )
//           }
//           getRowClassName={(params) =>
//             selectedRow?.id === params.id ? "selected-grid-row" : ""
//           }
//         />
//       </div>

//       {/* PDF DIALOG */}
//       <Dialog
//         open={isPdfDialogOpen}
//         onClose={closePdfDialog}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: "24px",
//             backgroundColor: "#ffffff",
//             boxShadow: "0 30px 80px rgba(15, 23, 42, 0.2)",
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, fontSize: 20, color: "#0f172a" }}>
//           Export options
//         </DialogTitle>

//         <DialogContent dividers className="section-picker">
//           <p>Select which sections you want to include in the PDF.</p>

//           <FormGroup>
//             <Grid container spacing={1}>
//               {[
//                 { key: "design", label: "Design parameters" },
//                 // { key: "airDischarge", label: "Air Discharge" },
//                 { key: "compressor", label: "Compressor" },
//                 { key: "condenserFan", label: "Condenser Fan" },
//                 { key: "condenser", label: "Condenser" },
//                 { key: "evaporator", label: "Evaporator" },
//                 // { key: "pump", label: "Pump" },
//                 { key: "controller", label: "Controller" },
//                 { key: "refrigerant", label: "Refrigerant" },
//                 { key: "expansionValve", label: "Expansion Valve" },
//                 { key: "protections", label: "Protections" },
//                 { key: "physicalSpecs", label: "Physical Specs" },
//                 { key: "performanceParameters", label: "Performance Parameters" },
//                 { key: "componentSummary", label: "Component Summary" },
//               ].map((item) => (
//                 <Grid item xs={6} key={item.key}>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={sectionState[item.key]}
//                         onChange={() => toggleSection(item.key)}
//                       />
//                     }
//                     label={item.label}
//                   />
//                 </Grid>
//               ))}
//             </Grid>
//           </FormGroup>
//         </DialogContent>

//         <DialogActions sx={{ padding: "16px 24px", gap: 1.5 }}>
//           <Button
//             sx={{
//               backgroundColor: "#0f172a27",
//               color: "#0f172a",
//               borderRadius: "12px",
//             }}
//             onClick={closePdfDialog}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             sx={{
//               backgroundColor: "#0f172a",
//               color: "#fff",
//               borderRadius: "12px",
//             }}
//             onClick={handleGeneratePDF}
//             disabled={isFullProfileLoading || !chillerFullProfile}
//           >
//             {isFullProfileLoading ? "Loading..." : "Download PDF"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

/* ####################### CODE VERSION 3 ####################### */

// import { useState, useEffect, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import AppContext from "../context/AppContext";
// import {
//   Button,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
//   Grid,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import "./ResultScreen.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { toast } from "react-toastify";
// import Eurovent_Cerificate from "../assets/images/Eurovent_Cerificate.jpeg"

// /* --------------------------
//     Filter Dropdown Component
// -------------------------- */
// const FilterControl = ({ label, value, onChange }) => (
//   <label className="result-filter">
//     <span>{label}</span>
//     <Select
//       size="small"
//       value={value}
//       onChange={onChange}
//       className="result-filter__select"
//     >
//       <MenuItem value="ALL">ALL</MenuItem>
//     </Select>
//   </label>
// );

// export default function ResultScreen() {
//   const navigate = useNavigate();

//   const {
//     base_URL,
//     chillersList,
//     setChillersList,
//     selectedSeries,
//     inletTemp,
//     outletTemp,
//     ambientTemp,
//   } = useContext(AppContext);

//   const [range, setRange] = useState("ALL");
//   const [version, setVersion] = useState("ALL");
//   const [option, setOption] = useState("ALL");
//   const [rows, setRows] = useState(chillersList);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [fetchError, setFetchError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);
//   const [isFullProfileLoading, setIsFullProfileLoading] = useState(false);
//   const [chillerFullProfile, setChillerFullProfile] = useState(null);

//   const [pumpSelection, setPumpSelection] = useState({}); // Pump Option

//   /* --------------------------
//       SECTION CHECKBOX STATE
//   -------------------------- */
//   const [sectionState, setSectionState] = useState({
//     performanceParameters: true,
//     componentSummary: true,
//     design: true,
//     compressor: true,
//     condenserFan: true,
//     condenser: true,
//     evaporator: true,
//     // pump: true,
//     controller: true,
//     refrigerant: true,
//     protections: true,
//     physicalSpecs: true,
//   });

//   const toggleSection = (key) =>
//     setSectionState((prev) => ({ ...prev, [key]: !prev[key] }));

//   /* --------------------------
//       TABLE COLUMNS
//   -------------------------- */
//   const columns = [
//     { field: "eurovent_certified", headerName: "Eurovent Certified", width: 165,
//       sortable: false,
//       filterable: false,
//       renderCell: () => (
//         <div
//       style={{
//         width: "100%",
//         height: "100%",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       <img
//         src={Eurovent_Cerificate}
//         alt="Eurovent"
//         style={{ width: 70, height: 70, objectFit: "contain" }}
//       />
//     </div>
//       ),
//     },
//     { field: "series_code", headerName: "Series", width: 100 },
//     { field: "model", headerName: "Model", width: 130 },
//     // { field: "model_size", headerName: "Size", width: 110 },
//     // { field: "version", headerName: "Version", width: 110 },
//     // { field: "option_code", headerName: "Option", width: 115 },

//     { field: "cooling_capacity_kw", headerName: "Cooling (kW)", width: 140 },
//     { field: "tpl_kw", headerName: "Power TPL (kW)", width: 140 },
//     { field: "eer", headerName: "EER (COP)", width: 110 },
//     // { field: "seer", headerName: "SEER", width: 110 },

//     { field: "refrigerant", headerName: "Refrigerant", width: 140 },
//     { field: "compressor_type", headerName: "Compressor", width: 140 },
//     { field: "evaporator_type", headerName: "Evaporator", width: 140 },
//     { field: "fan_type", headerName: "Fan Type", width: 120 },
//     // { field: "lw_flag", headerName: "Low Noise", width: 100, type: "boolean" },
//     {
//       field: "pump_select",
//       headerName: "Pump Option",
//       width: 120,
//       sortable: false,
//       filterable: false,
//       renderCell: (params) => {
//         const id = params.row.id;

//         return (
//           <input
//             type="checkbox"
//             checked={!!pumpSelection[id]}
//             className="result-pump-checkbox"
//             onChange={(e) => {
//               setPumpSelection((prev) => ({
//                 ...prev,
//                 [id]: e.target.checked,
//               }));
//             }}
//             style={{ width: 18, height: 18 }}
//           />
//         );
//       },
//     },
//   ];

//   /* --------------------------
//       FETCH SEARCH RESULTS
//   -------------------------- */
//   useEffect(() => {
//     const tempsProvided =
//       inletTemp !== "" && outletTemp !== "" && ambientTemp !== "";

//     if (!selectedSeries.length || !tempsProvided) {
//       setRows([]);
//       setChillersList([]);
//       return;
//     }

//     const controller = new AbortController();

//     const fetchChillers = async () => {
//       try {
//         setIsLoading(true);
//         setFetchError("");

//         const payload = {
//           seriesCodes: selectedSeries,
//           inletTemp,
//           outletTemp,
//           ambientTemp,
//         };

//         const response = await fetch(`${base_URL}/api/chillers/search`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//           signal: controller.signal,
//         });

//         const body = await response.json();

//         if (!response.ok) throw new Error(body?.error || "Fetch failed");

//         setRows(body.data ?? []);
//         setChillersList(body.data ?? []);
//       } catch (error) {
//         if (error.name === "AbortError") return;
//         setRows([]);
//         setChillersList([]);
//         setFetchError(error.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchChillers();
//     return () => controller.abort();
//   }, [base_URL, selectedSeries, inletTemp, outletTemp, ambientTemp, setChillersList]);

//   /* --------------------------
//       FETCH FULL PROFILE WHEN DIALOG OPENS
//   -------------------------- */
//   const openPdfDialog = async () => {
//     if (!selectedRow) return;

//     setIsPdfDialogOpen(true);
//     setIsFullProfileLoading(true);
//     setChillerFullProfile(null);

//     try {
//       const chillerId = selectedRow.id;
//       const response = await fetch(
//         `${base_URL}/api/chillers/${chillerId}/full-profile`
//       );

//       if (!response.ok) throw new Error("Failed to load full profile");

//       const data = await response.json();
//       console.log(`full profile data for chiller_id: ${chillerId}`, data);
//       setChillerFullProfile(data);
//     } catch (error) {
//       toast.error("Failed to load full profile");
//     } finally {
//       setIsFullProfileLoading(false);
//     }
//   };

//   const closePdfDialog = () => setIsPdfDialogOpen(false);

//   const handleGenerateClick = () => {
//     if (!selectedRow) {
//       toast.warn("Choose a row from the Table");
//       return;
//     }
//     openPdfDialog();
//   };

//   /* --------------------------
//       PDF HELPERS
//   -------------------------- */

// const EXCLUDE_KEYS = new Set(["id", "chiller_id", "created_at", "updated_at"]);

//   const valueOrDash = (v) =>
//     v !== null && v !== undefined && v !== "" ? v : "—";

//   const buildSingleSection = (sno, title, obj) => {
//     if (!obj) return [];

//     const filtered = Object.entries(obj).filter(
//       ([key]) => !EXCLUDE_KEYS.has(key)
//     );

//     return [
//       [
//         {
//           content: sno,
//           rowSpan: filtered.length + 1,
//           styles: { valign: "middle", halign: "center" },
//         },
//         { content: title, styles: { fontStyle: "bold" } },
//         "",
//         "",
//         "",
//       ],
//       ...filtered.map(([key, val]) => [
//         key.replace(/_/g, " ").toUpperCase(),
//         "",
//         valueOrDash(val),
//         "",
//       ]),
//     ];
//   };

//   const buildMultiSection = (sno, title, rows) => {
//   if (!rows || rows.length === 0) return [];

//   // Take only first object if needed
//   const firstRow = Array.isArray(rows) ? rows[0] : rows;

//   const filtered = Object.entries(firstRow).filter(
//     ([key]) => !EXCLUDE_KEYS.has(key)
//   );

//   if (filtered.length === 0) return [];

//   const detailRows = filtered.map(([key, val]) => ([
//     `${key.replace(/_/g, " ").toUpperCase()}`,
//     "",
//     valueOrDash(val),
//     ""
//   ]));

//   return [
//     [
//       {
//         content: sno,
//         rowSpan: detailRows.length + 1,
//         styles: { valign: "middle", halign: "center" }
//       },
//       { content: title, styles: { fontStyle: "bold" } },
//       "",
//       "",
//       ""
//     ],
//     ...detailRows
//   ];
// };

//   /* --------------------------
//       GENERATE PDF
//   -------------------------- */
//   const handleGeneratePDF = () => {
//     if (!chillerFullProfile) {
//       toast.warn("Profile is not loaded yet");
//       return;
//     }

//     const p = chillerFullProfile;
//     const doc = new jsPDF("p", "mm", "a4");

//     const modelLabel = p.chiller.model;
//     const sizeLabel = p.chiller.model_size;

//     /* HEADER */
//     autoTable(doc, {
//       startY: 10,
//       theme: "grid",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [
//         [
//           {
//             content: `FINAL SPECIFICATION - ${selectedSeries} - CHILLER`,
//             styles: { halign: "center", fontSize: 10, fontStyle: "bold" },
//           },
//           {
//             content: `REV : FINAL\nDATE : ${new Date().toLocaleDateString()}`,
//             styles: { halign: "left", fontSize: 8 },
//           },
//         ],
//       ],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },

//     });

//     /* MODEL */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "grid",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [[{ content: `Series : ${selectedSeries}`, styles: { fontStyle: "bold" } }]],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },
//     });

//     /* MAIN CONTENT */
//     let bodyRows = [];
//     let sno = 2;
//     bodyRows.push(["1", "Model", "", `${modelLabel}`, ""]);

//     if (sectionState.performanceParameters)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Performance Parameters", p.performance_parameters)
//       );

//     if (sectionState.componentSummary)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Component Summary", p.component_summary)
//       );

//     if (sectionState.design)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Design Parameters", p.design_parameters)
//       );

//     if (sectionState.compressor)
//       bodyRows.push(
//         ...buildMultiSection(sno++, "Compressor", p.compressors)
//       );

//     if (sectionState.condenserFan)
//       bodyRows.push(
//         ...buildMultiSection(sno++, "Condenser Fan", p.condenser_fans)
//       );

//     if (sectionState.condenser)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Condenser", p.condensers)
//       );

//     if (sectionState.evaporator)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Evaporator", p.evaporators)
//       );

//     if (sectionState.controller)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Controller", p.controller)
//       );

//     if (sectionState.refrigerant)
//       bodyRows.push(
//         ...buildMultiSection(sno++, "Refrigerant", p.refrigerants)
//       );

//     if (sectionState.protections)
//       bodyRows.push(
//         ...buildMultiSection(sno++, "Protections", p.protections)
//       );

//     // if (sectionState.pump)
//     //   bodyRows.push(
//     //     ...buildMultiSection(sno++, "Pump", p.circulation_pumps)
//     //   );

//     const selectedPump = pumpSelection[selectedRow?.id] === true;

//     if (selectedPump) {
//       bodyRows.push(
//         ...buildMultiSection(sno++, "Pump", p.circulation_pumps)
//       );
//     }

//     if (sectionState.physicalSpecs)
//       bodyRows.push(
//         ...buildSingleSection(sno++, "Physical Specs", p.physical_specs)
//       );

//     /* FINAL TABLE */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "grid",
//       head: [["S.No", "Description", "Unit", "PW", "Remarks"]],
//       body: bodyRows,
//       margin: { left: 10, right: 10 },
//       headStyles: {
//          fillColor: [255, 255, 255],
//          textColor: [0, 0, 0],
//          fontStyle: "bold",
//          halign: "center",
//          fontSize: 8,
//        },
//        styles: {
//          cellPadding: 1,
//          lineWidth: 0.3,
//          lineColor: [0, 0, 0],
//          fontSize: 8,
//          overflow: "linebreak",
//        },
//        columnStyles: {
//          0: { cellWidth: 12, halign: "center" },
//          1: { cellWidth: 60 },
//          2: { cellWidth: 12, halign: "center" },
//          3: { cellWidth: 86, halign: "center" }, // PW (internally split)
//          4: { cellWidth: 20, halign: "center" },
//        },
//     });

//     doc.save(`SPEC_${modelLabel}_${sizeLabel}.pdf`);
//     closePdfDialog();
//   };

//   /* --------------------------
//       JSX UI
//   -------------------------- */
//   return (
//     <div className="result-screen">
//       <header className="result-heading">
//         <div className="result-heading__left">
//           <Button
//             variant="outlined"
//             disableElevation
//             onClick={() => navigate(-1)}
//             sx={{
//               minWidth: 44,
//               height: 40,
//               borderRadius: "16px",
//               border: "none",
//             }}
//           >
//             <ArrowBackIosNewIcon sx={{ fontSize: 22, color: "#0f172a" }} />
//           </Button>
//           <div>
//             <p>Selection</p>
//             <h1>Results</h1>
//           </div>
//         </div>
//         <span className="result-heading__meta">{rows.length} models</span>
//       </header>

//       <div className="result-toolbar">

//         <div className="result-toolbar__filters">
//           <FilterControl label="Range" value={range} onChange={(e) => setRange(e.target.value)} />
//           <FilterControl label="Version" value={version} onChange={(e) => setVersion(e.target.value)} />
//           <FilterControl label="Option" value={option} onChange={(e) => setOption(e.target.value)} />

//         </div>
//         {/* <FormControlLabel
//           control={
//             <Checkbox
//               checked={includePump}
//               onChange={() => setIncludePump(!includePump)}
//             />
//           }
//           label="Include Pump"
//         /> */}
//         <Button
//           variant="contained"
//           disableElevation
//           onClick={handleGenerateClick}
//           aria-disabled={!selectedRow}
//           sx={{
//             textTransform: "none",
//             padding: "10px 26px",
//             borderRadius: "12px",
//             backgroundColor: selectedRow ? "#0f172a" : "#cbd5e1",
//             color: selectedRow ? "#fff" : "#94a3b8",
//             cursor: selectedRow ? "pointer" : "not-allowed",
//             "&:hover": {
//               backgroundColor: selectedRow ? "#0c1328" : "#cbd5e1",
//             },
//           }}
//           // className="result-toolbar__cta"
//         >
//           Generate PDF
//         </Button>
//       </div>

//       {fetchError && <div className="result-error-banner">{fetchError}</div>}

//       <div className="result-table">
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           loading={isLoading}
//           disableColumnMenu
//           onRowClick={(params) =>
//             setSelectedRow((prev) => (prev?.id === params.id ? null : params.row))
//           }
//           getRowClassName={(params) =>
//             selectedRow?.id === params.id ? "selected-grid-row" : ""
//           }
//         />
//       </div>

//       {/* PDF DIALOG */}
//       <Dialog
//         open={isPdfDialogOpen}
//         onClose={closePdfDialog}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: "24px",
//             backgroundColor: "#ffffff",
//             boxShadow: "0 30px 80px rgba(15, 23, 42, 0.2)",
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, fontSize: 20, color: "#0f172a" }}>
//           Export options
//         </DialogTitle>

//         <DialogContent dividers className="section-picker">
//           <p>Select which sections you want to include in the PDF.</p>

//           <FormGroup>
//             <Grid container spacing={1}>
//               {[
//                 { key: "design", label: "Design parameters" },
//                 { key: "compressor", label: "Compressor" },
//                 { key: "condenserFan", label: "Condenser Fan" },
//                 { key: "condenser", label: "Condenser" },
//                 { key: "evaporator", label: "Evaporator" },
//                 // { key: "pump", label: "Pump" },
//                 { key: "controller", label: "Controller" },
//                 { key: "refrigerant", label: "Refrigerant" },
//                 { key: "protections", label: "Protections" },
//                 { key: "physicalSpecs", label: "Physical Specs" },
//                 { key: "performanceParameters", label: "Performance Parameters" },
//                 { key: "componentSummary", label: "Component Summary" },
//               ].map((item) => (
//                 <Grid item xs={6} key={item.key}>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={sectionState[item.key]}
//                         onChange={() => toggleSection(item.key)}
//                       />
//                     }
//                     label={item.label}
//                   />
//                 </Grid>
//               ))}
//             </Grid>

//           </FormGroup>
//         </DialogContent>

//         <DialogActions sx={{ padding: "16px 24px", gap: 1.5 }}>
//           <Button
//             sx={{ backgroundColor: "#0f172a27", color: "#0f172a", borderRadius: "12px" }}
//             onClick={closePdfDialog}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             sx={{ backgroundColor: "#0f172a", color: "#fff", borderRadius: "12px" }}
//             onClick={handleGeneratePDF}
//             disabled={isFullProfileLoading || !chillerFullProfile}
//           >
//             {isFullProfileLoading ? "Loading..." : "Download PDF"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

/* ####################### CODE VERSION 2 ####################### */

// import { useState, useEffect, useContext } from "react";
// import AppContext from "../context/AppContext";
// import {
//   Button,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
//   Grid,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import "./ResultScreen.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { toast } from "react-toastify";

// /* --------------------------
//     Filter Dropdown Component
// -------------------------- */
// const FilterControl = ({ label, value, onChange }) => (
//   <label className="result-filter">
//     <span>{label}</span>
//     <Select
//       size="small"
//       value={value}
//       onChange={onChange}
//       className="result-filter__select"
//     >
//       <MenuItem value="ALL">ALL</MenuItem>
//     </Select>
//   </label>
// );

// export default function ResultScreen() {
//   const {
//     base_URL,
//     chillersList,
//     setChillersList,
//     selectedSeries,
//     inletTemp,
//     outletTemp,
//     ambientTemp,
//   } = useContext(AppContext);

//   const [range, setRange] = useState("ALL");
//   const [version, setVersion] = useState("ALL");
//   const [option, setOption] = useState("ALL");
//   const [rows, setRows] = useState(chillersList);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState("");
//   const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);
//   const [chillerFullProfile, setChillerFullProfile] = useState(null);
//   const [isChillerFullProfileLoading, setIsChillerFullProfileLoading] = useState(false);

//   /* --------------------------
//       SECTION CHECKBOX STATE
//   -------------------------- */
//   const [sectionState, setSectionState] = useState({
//     design: true,
//     compressor: true,
//     condenserFan: true,
//     condenser: true,
//     evaporator: true,
//     pump: true,
//     controller: true,
//     refrigerant: true,
//     protections: true,
//     physicalSpecs: true,
//     performanceParameters: true,
//     componentSummary: true,
//   });

//   const toggleSection = (key) =>
//     setSectionState((prev) => ({ ...prev, [key]: !prev[key] }));

//   /* --------------------------
//       Table Columns
//   -------------------------- */
//   const columns = [
//     { field: "model", headerName: "Model", width: 120 },
//     { field: "series_code", headerName: "Series", width: 105 },
//     { field: "model_size", headerName: "Size", width: 110 },
//     { field: "version", headerName: "Version", width: 110 },
//     { field: "option_code", headerName: "Option", width: 115 },

//     { field: "refrigerant", headerName: "Refrigerant", width: 130 },
//     { field: "compressor_type", headerName: "Compressor", width: 140 },
//     { field: "evaporator_type", headerName: "Evaporator", width: 140 },
//     { field: "fan_type", headerName: "Fan Type", width: 120 },
//     { field: "lw_flag", headerName: "Low Noise", width: 100, type: "boolean" },

//     { field: "cooling_capacity_kw", headerName: "Cooling (kW)", width: 150 },
//     { field: "tpl_kw", headerName: "TPL (kW)", width: 120 },
//     { field: "eer", headerName: "EER", width: 110 },
//     { field: "seer", headerName: "SEER", width: 110 },
//   ];

//   useEffect(() => {
//     const tempsProvided =
//       inletTemp !== "" && outletTemp !== "" && ambientTemp !== "";

//     if (!selectedSeries.length || !tempsProvided) {
//       setRows([]);
//       setChillersList([]);
//       return;
//     }

//     const controller = new AbortController();
//     const fetchChillers = async () => {
//       try {
//         setIsLoading(true);
//         setFetchError("");

//         const payload = {
//           seriesCodes: selectedSeries,
//           inletTemp,
//           outletTemp,
//           ambientTemp,
//         };

//         const response = await fetch(`${base_URL}/api/chillers/search`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//           signal: controller.signal,
//         });

//         const body = await response.json();

//         if (!response.ok) {
//           const message =
//             body?.error ||
//             body?.message ||
//             "Unable to fetch chillers. Please try again.";
//           throw new Error(message);
//         }

//         const data = body?.data ?? [];
//         console.log("searched chillers list data", data);

//         setRows(data);
//         setChillersList(data);
//       } catch (error) {
//         if (error.name === "AbortError") return;
//         setRows([]);
//         setChillersList([]);
//         setFetchError(error.message);
//         console.error("Failed to fetch chillers:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchChillers();

//     return () => controller.abort();
//   }, [
//     base_URL,
//     selectedSeries,
//     inletTemp,
//     outletTemp,
//     ambientTemp,
//     setChillersList,
//   ]);

// const openPdfDialog = async () => {
//   if (!selectedRow) return;

//   setIsPdfDialogOpen(true);
//   setIsChillerFullProfileLoading(true);
//   setChillerFullProfile(null);

//   try {
//     const chillerId = selectedRow.id;

//     const response = await fetch(`${base_URL}/api/chillers/${chillerId}/full-profile`);

//     if (!response.ok) {
//       throw new Error("Failed to fetch full profile");
//     }

//     const data = await response.json();
//     console.log("FULL PROFILE DATA:", data);

//     setChillerFullProfile(data);
//   } catch (error) {
//       toast.error("Failed to load full profile");
//       setChillerFullProfile(null);
//   } finally {
//       setIsChillerFullProfileLoading(false);
//   }
// };
//   const closePdfDialog = () => setIsPdfDialogOpen(false);

//   useEffect(() => {
//     if (!rows.length) {
//       setSelectedRow(null);
//     }
//   }, [rows.length]);

//   /* --------------------------------------------------------------------
//         SECTION ROW BUILDERS (Design, Compressor, etc.)
//      -------------------------------------------------------------------- */

//   const getDesignParametersRows = (sno) => [
//     [
//       {
//         content: sno,
//         rowSpan: 8,
//         styles: { valign: "middle", halign: "center" },
//       },
//       { content: "Design Parameters", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],

//     // Cooling Capacity
//     [
//       {
//         content: "a. Cooling Capacity",
//         rowSpan: 2,
//         styles: { valign: "middle" },
//       },
//       "°C",
//       "Ambient Temp - 35°C || Ambient Temp - 46°C || Ambient Temp - 53°C",
//       "",
//     ],
//     ["KW", "11.5–12.4 || 9.9 || 7.27–7.9", ""],

//     // Other rows
//     ["b. Running Power / Maximum Power", "KW", "2.99 || 3.62 || 4.03", ""],
//     ["c. Maximum Current", "A", "13.4 || 16.1 || 17.9", ""],
//     ["d. COP", "", "4.16 || 2.71 || 1.95", ""],
//     ["e. Maximum Ambient Temperature", "°C", "53", ""],
//     ["f. Air Discharge", "", "Top air discharge", ""],
//   ];

//   const getCompressorRows = (sno) => [
//     [
//       {
//         content: sno,
//         rowSpan: 4,
//         styles: { valign: "middle", halign: "center" },
//       },
//       { content: "Compressor", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type & Quantity", "", "Rotary, 1 No.", ""],
//     ["b. Make & Model", "", "GMCC / ATQ360V1SMP", ""],
//     ["c. LRA & FLA", "A", "74 / 14.15", ""],
//   ];

//   const getCondenserFanRows = (sno) => [
//     [
//       {
//         content: sno,
//         rowSpan: 8,
//         styles: { valign: "middle", halign: "center" },
//       },
//       { content: "Condenser fan", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type & Quantity", "", "Axial Flow Fan, 1 No.", ""],
//     [
//       "b. Blade Material",
//       "",
//       "Aluminium blades suitable for corrosive environment",
//       "",
//     ],
//     ["c. Motor - Make & Model", "", "JF Brand/YDK-100-6A-B1", ""],
//     ["d. IP Rating", "", "IP 44 + special corrosive coating", ""],
//     [
//       "e. Air flow rate & Rotation Speed",
//       "CFM\nRPM",
//       "1823.4 CFM (3100 m³/h) / 750±30 (r/min)",
//       "",
//     ],
//     ["f. Full Load Amperage", "A", "0.85", ""],
//     [
//       "g. Fan grill - Material & Coating",
//       "",
//       "Electroplated Iron Mesh + 720 hours salt spray tested coating",
//       "",
//     ],
//   ];

//   const getCondenserRows = (sno) => [
//     [
//       {
//         content: sno,
//         rowSpan: 4,
//         styles: { valign: "middle", halign: "center" },
//       },
//       { content: "Condensor", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type", "", "Copper tube bonded with aluminium Fins", ""],
//     [
//       "b. Construction",
//       "",
//       "Hydrophilic coated aluminum fins and coils with 1500 hours salt spray tested coating",
//       "",
//     ],
//     [
//       "c. Protection guard - Material & Coating",
//       "",
//       "Electroplated iron Mesh with 720 hours salt spray tested coating",
//       "",
//     ],
//   ];

//   const getEvaporatorRows = (sno) => [
//     [
//       {
//         content: sno,
//         rowSpan: 5,
//         styles: { valign: "middle", halign: "center" },
//       },
//       { content: "Evaporator", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     [
//       "a. PHE",
//       "",
//       "Brazed Plate Heat Exchanger suitable for potable water",
//       "",
//     ],
//     ["b. Material", "", "SS 316 L", ""],
//     ["c. Make & Model", "", "Hrale Brand/B3-40-50-4.5", ""],
//     ["d. Pressure drop", "Bar", "0.1", ""],
//   ];

//   /* --------------------------------------------------------------------
//       PDF GENERATOR FUNCTION
//   -------------------------------------------------------------------- */
//   const handleGeneratePDF =  () => {
//     if (!chillerFullProfile) {
//       toast.warn("Full profile is not loaded yet");
//       return;
//     }

//     const modelLabel =
//       selectedRow.model ?? selectedRow.series_code ?? "Chiller";
//     const sizeLabel = selectedRow.model_size ?? "N/A";

//     const doc = new jsPDF("p", "mm", "a4");

//     /* ---------------------------
//         HEADER SECTION
//     --------------------------- */
//     autoTable(doc, {
//       startY: 10,
//       theme: "plain",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [
//         [
//           {
//             content: "FINAL SPECIFICATION - PW - CHILLER",
//             styles: { halign: "center", fontSize: 10, fontStyle: "bold" },
//           },
//           {
//             content: `REV : FINAL\nDATE : ${new Date().toLocaleDateString()}`,
//             styles: { halign: "left", fontSize: 8 },
//           },
//         ],
//       ],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },
//     });

//     /* ---------------------------
//         MODEL ROW
//     --------------------------- */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "plain",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [
//         [
//           {
//             content: `Model : ${modelLabel}`,
//             styles: { fontStyle: "bold", fontSize: 8 },
//           },
//         ],
//       ],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },
//     });

//     /* ---------------------------
//         BUILD DYNAMIC TABLE ROWS
//     --------------------------- */
//     let bodyRows = [];
//     let sno = 2;
//     bodyRows.push(["1", "Model", "", "", ""]); // Always included

//     if (sectionState.design) bodyRows.push(...getDesignParametersRows(sno++));
//     if (sectionState.compressor) bodyRows.push(...getCompressorRows(sno++));
//     if (sectionState.condenserFan) bodyRows.push(...getCondenserFanRows(sno++));
//     if (sectionState.condenser) bodyRows.push(...getCondenserRows(sno++));
//     if (sectionState.evaporator) bodyRows.push(...getEvaporatorRows(sno++));

//     /* ---------------------------
//         MAIN TABLE
//     --------------------------- */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "grid",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       head: [["S.No", "Description", "Unit", "PW", "Remarks"]],
//       body: bodyRows,

//       /* -------------------------------------------------------------
//           PW COLUMN SPLITTER (custom drawing)
//       ------------------------------------------------------------- */
//       didDrawCell: function (data) {
//         if (data.column.index !== 3 || data.cell.section !== "body") return;

//         const doc = data.doc;

//         const rowsNeedingSplit = [
//           "a. Cooling Capacity",
//           "b. Running Power / Maximum Power",
//           "c. Maximum Current",
//           "d. COP",
//         ];

//         let desc = data.row.raw[1];
//         if (typeof desc === "object") desc = desc.content;

//         if (!rowsNeedingSplit.includes(desc)) return;

//         const { x, y, width, height } = data.cell;
//         const colWidth = width / 3;

//         // Draw separators
//         doc.setLineWidth(0.3);
//         doc.line(x + colWidth, y, x + colWidth, y + height);
//         doc.line(x + colWidth * 2, y, x + colWidth * 2, y + height);

//         // Draw text
//         const values = data.cell.text[0].split("||").map((v) => v.trim());
//         doc.setFontSize(7);

//         values.forEach((val, i) => {
//           const tx = x + colWidth * i + 2;
//           const ty = y + height / 2 + 2;
//           doc.text(val, tx, ty);
//         });

//         // Prevent autoTable from double-printing text
//         data.cell.text = [""];
//       },

//       headStyles: {
//         fillColor: [255, 255, 255],
//         textColor: [0, 0, 0],
//         fontStyle: "bold",
//         halign: "center",
//         fontSize: 8,
//       },
//       styles: {
//         cellPadding: 1,
//         lineWidth: 0.3,
//         lineColor: [0, 0, 0],
//         fontSize: 8,
//         overflow: "linebreak",
//       },

//       columnStyles: {
//         0: { cellWidth: 12, halign: "center" },
//         1: { cellWidth: 60 },
//         2: { cellWidth: 12, halign: "center" },
//         3: { cellWidth: 86 }, // PW (internally split)
//         4: { cellWidth: 20, halign: "center" },
//       },
//     });

//     /* ---------------------------
//         SAVE PDF
//     --------------------------- */
//     doc.save(`SPEC_${modelLabel}_${sizeLabel}.pdf`);
//     closePdfDialog();
//   };

//   /* --------------------------
//         JSX UI RENDER
//   -------------------------- */
//   return (
//     <div className="result-screen">
//       <header className="result-heading">
//         <div>
//           <p>Selection</p>
//           <h1>Results</h1>
//         </div>
//         <span className="result-heading__meta">{rows.length} models</span>
//       </header>

//       <div className="result-toolbar">
//         <div className="result-toolbar__filters">
//           <FilterControl
//             label="Range"
//             value={range}
//             onChange={(e) => setRange(e.target.value)}
//           />
//           <FilterControl
//             label="Version"
//             value={version}
//             onChange={(e) => setVersion(e.target.value)}
//           />
//           <FilterControl
//             label="Option"
//             value={option}
//             onChange={(e) => setOption(e.target.value)}
//           />
//         </div>

//         <Button
//           variant="contained"
//           disableElevation
//           onClick={openPdfDialog}
//           disabled={!selectedRow}
//           className="result-toolbar__cta"
//         >
//           Generate PDF
//         </Button>
//       </div>

//       {fetchError && <div className="result-error-banner">{fetchError}</div>}

//       <div className="result-table">
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           loading={isLoading}
//           disableColumnMenu
//           // disableRowSelectionOnClick
//           onRowClick={(params) => setSelectedRow(params.row)}
//           // Highlight selected row
//           getRowClassName={(params) =>
//             selectedRow?.id === params.id ? "selected-grid-row" : ""
//           }
//         />
//       </div>

//       {/* --------------------------
//           PDF EXPORT DIALOG
//       -------------------------- */}
//       <Dialog
//         open={isPdfDialogOpen}
//         onClose={closePdfDialog}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: "24px",
//             backgroundColor: "#ffffff",
//             boxShadow: "0 30px 80px rgba(15, 23, 42, 0.2)",
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, fontSize: 20, color: "#0f172a" }}>
//           Export options
//         </DialogTitle>

//         <DialogContent dividers className="section-picker">
//           <p>Select which sections you want to include in the PDF.</p>

//           <FormGroup>
//             <Grid container spacing={1}>
//             {[
//               { key: "design", label: "Design parameters" },
//               { key: "compressor", label: "Compressor" },
//               { key: "condenserFan", label: "Condenser Fan" },
//               { key: "condenser", label: "Condenser" },
//               { key: "evaporator", label: "Evaporator" },
//               { key: "pump", label: "Pump" },
//               { key: "controller", label: "Controller" },
//               { key: "refrigerant", label: "Refrigerant" },
//               { key: "protections", label: "Protections" },
//               { key: "physicalSpecs", label: "Physical Specs" },
//               { key: "performanceParameters", label: "Performance Parameters" },
//               { key: "componentSummary", label: "Component Summary" },
//              ].map((item) => (
//               <Grid item xs={6} key={item.key}>
//               <FormControlLabel
//                 key={item.key}
//                 control={
//                   <Checkbox
//                     checked={sectionState[item.key]}
//                     onChange={() => toggleSection(item.key)}
//                   />
//                 }
//                 label={item.label}
//               />
//               </Grid>
//             ))}
//             </Grid>
//           </FormGroup>
//         </DialogContent>

//         <DialogActions sx={{ padding: "16px 24px", gap: 1.5 }}>
//           <Button
//             sx={{ backgroundColor: "#0f172a27", color: "#0f172a" }}
//             onClick={closePdfDialog}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             sx={{ backgroundColor: "#0f172a", color: "#fff" }}
//             onClick={handleGeneratePDF}
//             disabled={!chillerFullProfile || isChillerFullProfileLoading}
//           >
//             {isChillerFullProfileLoading ? "Loading..." : "Download PDF"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

/* ####################### CODE VERSION 1 ####################### */

// import { useState, useEffect, useContext } from "react";
// import AppContext from "../context/AppContext";
// import {
//   Button,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { selectionResults } from "../assets/data/DummyData";
// import "./ResultScreen.css";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// /* --------------------------
//     Filter Dropdown Component
// -------------------------- */
// const FilterControl = ({ label, value, onChange }) => (
//   <label className="result-filter">
//     <span>{label}</span>
//     <Select
//       size="small"
//       value={value}
//       onChange={onChange}
//       className="result-filter__select"
//     >
//       <MenuItem value="ALL">ALL</MenuItem>
//     </Select>
//   </label>
// );

// export default function ResultScreen() {
//   const { inletTemp, outletTemp, ambientTemp } = useContext(AppContext);

//   const [range, setRange] = useState("ALL");
//   const [version, setVersion] = useState("ALL");
//   const [option, setOption] = useState("ALL");
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);

//   /* --------------------------
//       SECTION CHECKBOX STATE
//   -------------------------- */
//   const [sectionState, setSectionState] = useState({
//     design: true,
//     compressor: true,
//     condenserFan: true,
//     condenser: true,
//     evaporator: true,
//   });

//   const toggleSection = (key) =>
//     setSectionState((prev) => ({ ...prev, [key]: !prev[key] }));

//   /* --------------------------
//       Debug: Print incoming temps
//   -------------------------- */
//   useEffect(() => {
//     console.log("📌 ResultScreen Mounted");
//     console.log("Temps from context:", inletTemp, outletTemp, ambientTemp);
//   }, [inletTemp, outletTemp, ambientTemp]);

//   /* --------------------------
//       Table Columns
//   -------------------------- */
//   const columns = [
//     { field: "range", headerName: "Range", width: 120 },
//     { field: "version", headerName: "Version", width: 100 },
//     { field: "option", headerName: "Option", width: 100 },
//     { field: "size", headerName: "Size", width: 120 },
//     { field: "refrigerant", headerName: "Refrigerant", width: 120 },
//     { field: "compressor", headerName: "Compressor", width: 120 },
//     { field: "evaporator", headerName: "Evaporator", width: 120 },
//     { field: "fan", headerName: "Fan", width: 120 },
//     { field: "lwa", headerName: "Lwa dB(A)", width: 110 },
//     { field: "cc_kw", headerName: "CC kW", width: 100 },
//     { field: "tot_kw", headerName: "Tot kW", width: 100 },
//     { field: "eer", headerName: "EER kW/kW", width: 120 },
//     { field: "seer", headerName: "SEER", width: 100 },
//   ];

//   const openPdfDialog = () => setIsPdfDialogOpen(true);
//   const closePdfDialog = () => setIsPdfDialogOpen(false);

//   /* --------------------------------------------------------------------
//         SECTION ROW BUILDERS (Design, Compressor, etc.)
//      -------------------------------------------------------------------- */

//   const getDesignParametersRows = (sno) => [
//     [
//       { content: sno, rowSpan: 8, styles: { valign: "middle", halign: "center" } },
//       { content: "Design Parameters", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],

//     // Cooling Capacity
//     [
//       { content: "a. Cooling Capacity", rowSpan: 2, styles: { valign: "middle" } },
//       "°C",
//       "Ambient Temp - 35°C || Ambient Temp - 46°C || Ambient Temp - 53°C",
//       "",
//     ],
//     [
//       "KW",
//       "11.5–12.4 || 9.9 || 7.27–7.9",
//       "",
//     ],

//     // Other rows
//     ["b. Running Power / Maximum Power", "KW", "2.99 || 3.62 || 4.03", ""],
//     ["c. Maximum Current", "A", "13.4 || 16.1 || 17.9", ""],
//     ["d. COP", "", "4.16 || 2.71 || 1.95", ""],
//     ["e. Maximum Ambient Temperature", "°C", "53", ""],
//     ["f. Air Discharge", "", "Top air discharge", ""],
//   ];

//   const getCompressorRows = (sno) => [
//     [
//       { content: sno, rowSpan: 4, styles: { valign: "middle", halign: "center" } },
//       { content: "Compressor", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type & Quantity", "", "Rotary, 1 No.", ""],
//     ["b. Make & Model", "", "GMCC / ATQ360V1SMP", ""],
//     ["c. LRA & FLA", "A", "74 / 14.15", ""],
//   ];

//   const getCondenserFanRows = (sno) => [
//     [
//       { content: sno, rowSpan: 8, styles: { valign: "middle", halign: "center" } },
//       { content: "Condenser fan", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type & Quantity", "", "Axial Flow Fan, 1 No.", ""],
//     ["b. Blade Material", "", "Aluminium blades suitable for corrosive environment", ""],
//     ["c. Motor - Make & Model", "", "JF Brand/YDK-100-6A-B1", ""],
//     ["d. IP Rating", "", "IP 44 + special corrosive coating", ""],
//     [
//       "e. Air flow rate & Rotation Speed",
//       "CFM\nRPM",
//       "1823.4 CFM (3100 m³/h) / 750±30 (r/min)",
//       "",
//     ],
//     ["f. Full Load Amperage", "A", "0.85", ""],
//     ["g. Fan grill - Material & Coating", "", "Electroplated Iron Mesh + 720 hours salt spray tested coating", ""],
//   ];

//   const getCondenserRows = (sno) => [
//     [
//       { content: sno, rowSpan: 4, styles: { valign: "middle", halign: "center" } },
//       { content: "Condensor", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. Type", "", "Copper tube bonded with aluminium Fins", ""],
//     [
//       "b. Construction",
//       "",
//       "Hydrophilic coated aluminum fins and coils with 1500 hours salt spray tested coating",
//       "",
//     ],
//     [
//       "c. Protection guard - Material & Coating",
//       "",
//       "Electroplated iron Mesh with 720 hours salt spray tested coating",
//       "",
//     ],
//   ];

//   const getEvaporatorRows = (sno) => [
//     [
//       { content: sno, rowSpan: 5, styles: { valign: "middle", halign: "center" } },
//       { content: "Evaporator", styles: { fontStyle: "bold" } },
//       "",
//       "",
//       "",
//     ],
//     ["a. PHE", "", "Brazed Plate Heat Exchanger suitable for potable water", ""],
//     ["b. Material", "", "SS 316 L", ""],
//     ["c. Make & Model", "", "Hrale Brand/B3-40-50-4.5", ""],
//     ["d. Pressure drop", "Bar", "0.1", ""],
//   ];

//   /* --------------------------------------------------------------------
//       PDF GENERATOR FUNCTION
//   -------------------------------------------------------------------- */
//   const handleGeneratePDF = () => {
//     if (!selectedRow) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     /* ---------------------------
//         HEADER SECTION
//     --------------------------- */
//     autoTable(doc, {
//       startY: 10,
//       theme: "plain",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [
//         [
//           {
//             content: "FINAL SPECIFICATION - PW - CHILLER",
//             styles: { halign: "center", fontSize: 10, fontStyle: "bold" },
//           },
//           {
//             content: `REV : FINAL\nDATE : ${new Date().toLocaleDateString()}`,
//             styles: { halign: "left", fontSize: 8 },
//           },
//         ],
//       ],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },
//     });

//     /* ---------------------------
//         MODEL ROW
//     --------------------------- */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "plain",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       body: [
//         [
//           {
//             content: `Model : ${selectedRow.range}`,
//             styles: { fontStyle: "bold", fontSize: 8 },
//           },
//         ],
//       ],
//       styles: { cellPadding: 2, lineWidth: 0.3, lineColor: [0, 0, 0] },
//     });

//     /* ---------------------------
//         BUILD DYNAMIC TABLE ROWS
//     --------------------------- */
//     let bodyRows = [];
//     let sno = 2;
//     bodyRows.push(["1", "Model", "", "", ""]); // Always included

//     if (sectionState.design) bodyRows.push(...getDesignParametersRows(sno++));
//     if (sectionState.compressor) bodyRows.push(...getCompressorRows(sno++));
//     if (sectionState.condenserFan) bodyRows.push(...getCondenserFanRows(sno++));
//     if (sectionState.condenser) bodyRows.push(...getCondenserRows(sno++));
//     if (sectionState.evaporator) bodyRows.push(...getEvaporatorRows(sno++));

//     /* ---------------------------
//         MAIN TABLE
//     --------------------------- */
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY,
//       theme: "grid",
//       tableWidth: 190,
//       margin: { left: 10, right: 10 },
//       head: [["S.No", "Description", "Unit", "PW", "Remarks"]],
//       body: bodyRows,

//       /* -------------------------------------------------------------
//           PW COLUMN SPLITTER (custom drawing)
//       ------------------------------------------------------------- */
//       didDrawCell: function (data) {
//         if (data.column.index !== 3 || data.cell.section !== "body") return;

//         const doc = data.doc;

//         const rowsNeedingSplit = [
//           "a. Cooling Capacity",
//           "b. Running Power / Maximum Power",
//           "c. Maximum Current",
//           "d. COP",
//         ];

//         let desc = data.row.raw[1];
//         if (typeof desc === "object") desc = desc.content;

//         if (!rowsNeedingSplit.includes(desc)) return;

//         const { x, y, width, height } = data.cell;
//         const colWidth = width / 3;

//         // Draw separators
//         doc.setLineWidth(0.3);
//         doc.line(x + colWidth, y, x + colWidth, y + height);
//         doc.line(x + colWidth * 2, y, x + colWidth * 2, y + height);

//         // Draw text
//         const values = data.cell.text[0].split("||").map(v => v.trim());
//         doc.setFontSize(7);

//         values.forEach((val, i) => {
//           const tx = x + colWidth * i + 2;
//           const ty = y + height / 2 + 2;
//           doc.text(val, tx, ty);
//         });

//         // Prevent autoTable from double-printing text
//         data.cell.text = [""];
//       },

//       headStyles: {
//         fillColor: [255, 255, 255],
//         textColor: [0, 0, 0],
//         fontStyle: "bold",
//         halign: "center",
//         fontSize: 8,
//       },
//       styles: {
//         cellPadding: 1,
//         lineWidth: 0.3,
//         lineColor: [0, 0, 0],
//         fontSize: 8,
//         overflow: "linebreak",
//       },

//       columnStyles: {
//         0: { cellWidth: 12, halign: "center" },
//         1: { cellWidth: 60 },
//         2: { cellWidth: 12, halign: "center" },
//         3: { cellWidth: 86 }, // PW (internally split)
//         4: { cellWidth: 20, halign: "center" },
//       },
//     });

//     /* ---------------------------
//         SAVE PDF
//     --------------------------- */
//     doc.save(`SPEC_${selectedRow.range}_${selectedRow.size}.pdf`);
//     closePdfDialog();
//   };

//   /* --------------------------
//         JSX UI RENDER
//   -------------------------- */
//   return (
//     <div className="result-screen">
//       <header className="result-heading">
//         <div>
//           <p>Selection</p>
//           <h1>Results</h1>
//         </div>
//         <span className="result-heading__meta">
//           {selectionResults.length} models
//         </span>
//       </header>

//       <div className="result-toolbar">
//         <div className="result-toolbar__filters">
//           <FilterControl label="Range" value={range} onChange={(e) => setRange(e.target.value)} />
//           <FilterControl label="Version" value={version} onChange={(e) => setVersion(e.target.value)} />
//           <FilterControl label="Option" value={option} onChange={(e) => setOption(e.target.value)} />
//         </div>

//         <Button
//           variant="contained"
//           disableElevation
//           onClick={openPdfDialog}
//           disabled={!selectedRow}
//           className="result-toolbar__cta"
//         >
//           Generate PDF
//         </Button>
//       </div>

//       <div className="result-table">
//         <DataGrid
//           rows={selectionResults}
//           columns={columns}
//           disableColumnMenu
//           onRowClick={(params) => setSelectedRow(params.row)}
//         />
//       </div>

//       {/* --------------------------
//           PDF EXPORT DIALOG
//       -------------------------- */}
//       <Dialog
//         open={isPdfDialogOpen}
//         onClose={closePdfDialog}
//         fullWidth
//         maxWidth="sm"
//         PaperProps={{
//           sx: {
//             borderRadius: "24px",
//             backgroundColor: "#ffffff",
//             boxShadow: "0 30px 80px rgba(15, 23, 42, 0.2)",
//           },
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 600, fontSize: 20, color: "#0f172a" }}>
//           Export options
//         </DialogTitle>

//         <DialogContent dividers className="section-picker">
//           <p>Select which sections you want to include in the PDF.</p>

//           <FormGroup>
//             {[
//               { key: "design", label: "Design parameters" },
//               { key: "compressor", label: "Compressor" },
//               { key: "condenserFan", label: "Condenser Fan" },
//               { key: "condenser", label: "Condenser" },
//               { key: "evaporator", label: "Evaporator" },
//             ].map((item) => (
//               <FormControlLabel
//                 key={item.key}
//                 control={
//                   <Checkbox
//                     checked={sectionState[item.key]}
//                     onChange={() => toggleSection(item.key)}
//                   />
//                 }
//                 label={item.label}
//               />
//             ))}
//           </FormGroup>
//         </DialogContent>

//         <DialogActions sx={{ padding: "16px 24px", gap: 1.5 }}>
//           <Button sx={{ backgroundColor: "#0f172a27", color: "#0f172a" }} onClick={closePdfDialog}>
//             Cancel
//           </Button>
//           <Button variant="contained" sx={{ backgroundColor: "#0f172a", color: "#fff" }} onClick={handleGeneratePDF}>
//             Download PDF
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }
